{
  "level": "eb07",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb07",
    "objects": "AREAS.E3:eb07.e3",
    "mesh": "TREES.E3:eb07.e3"
  },
  "spawn_point": {
    "position": [
      2026.92106648466,
      1953.7032333485402,
      394.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      2026.92106648466,
      2053.7032333485404,
      394.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1916.2593994140625,
      1843.8516845703125,
      370.0
    ],
    "bbox_max": [
      2131.328857421875,
      2054.961181640625,
      737.0
    ],
    "vertex_count": 685,
    "vertices": [
      [
        2051.67041015625,
        1859.3372802734375,
        370.0
      ],
      [
        2032.5865478515625,
        1878.4208984375,
        370.0
      ],
      [
        1954.7955322265625,
        1956.2119140625,
        370.0
      ],
      [
        1935.704833984375,
        1975.302734375,
        370.0
      ],
      [
        2032.5865478515625,
        1878.4208984375,
        370.0
      ],
      [
        1954.7955322265625,
        1956.2119140625,
        370.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        650.0
      ],
      [
        1983.7880859375,
        1927.219482421875,
        650.0
      ],
      [
        2029.15185546875,
        1881.855712890625,
        650.0
      ],
      [
        2039.7584228515625,
        1871.2491455078125,
        650.0
      ],
      [
        1947.6165771484375,
        1963.390869140625,
        650.0
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        650.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        649.7000122070312
      ],
      [
        2029.15185546875,
        1881.855712890625,
        649.7000122070312
      ],
      [
        1983.7880859375,
        1927.219482421875,
        649.7000122070312
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        649.7000122070312
      ],
      [
        1983.7880859375,
        1927.219482421875,
        650.0
      ],
      [
        1983.7880859375,
        1927.219482421875,
        649.7000122070312
      ],
      [
        2029.15185546875,
        1881.855712890625,
        649.7000122070312
      ],
      [
        2029.15185546875,
        1881.855712890625,
        650.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        650.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        649.7000122070312
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        649.7000122070312
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        650.0
      ],
      [
        2039.7584228515625,
        1871.2491455078125,
        665.0
      ],
      [
        2029.15185546875,
        1881.855712890625,
        665.0
      ],
      [
        1947.6165771484375,
        1963.390869140625,
        665.0
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        665.0
      ],
      [
        2029.15185546875,
        1881.855712890625,
        665.0
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        665.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        670.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        670.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        670.0
      ],
      [
        1944.897216796875,
        1966.1103515625,
        670.0
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        670.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        670.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        692.75
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        692.75
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        710.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        710.0
      ],
      [
        2019.1434326171875,
        1891.8642578125,
        732.0
      ],
      [
        2019.1434326171875,
        1891.8642578125,
        720.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        732.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        720.0
      ],
      [
        2012.072265625,
        1898.9351806640625,
        732.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        732.0
      ],
      [
        2012.072265625,
        1898.9351806640625,
        720.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        720.0
      ],
      [
        2019.1434326171875,
        1891.8642578125,
        732.0
      ],
      [
        2012.072265625,
        1898.9351806640625,
        732.0
      ],
      [
        2019.1434326171875,
        1891.8642578125,
        720.0
      ],
      [
        2012.072265625,
        1898.9351806640625,
        720.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        695.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        695.0
      ],
      [
        1951.6146240234375,
        1944.5435791015625,
        695.0
      ],
      [
        1948.0791015625,
        1948.0792236328125,
        695.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        695.0
      ],
      [
        1948.0791015625,
        1948.0792236328125,
        695.0
      ],
      [
        1941.008056640625,
        1962.2213134765625,
        689.9999389648438
      ],
      [
        1955.1502685546875,
        1948.0792236328125,
        689.9999389648438
      ],
      [
        1951.6146240234375,
        1944.5435791015625,
        694.0
      ],
      [
        1948.0791015625,
        1948.0792236328125,
        694.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        694.0
      ],
      [
        1948.0791015625,
        1948.0792236328125,
        694.0
      ],
      [
        1955.1502685546875,
        1948.0792236328125,
        694.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        695.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        694.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        694.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        695.0
      ],
      [
        1941.008056640625,
        1962.2213134765625,
        694.0
      ],
      [
        1955.1502685546875,
        1948.0792236328125,
        689.9999389648438
      ],
      [
        1951.61474609375,
        1944.543701171875,
        690.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        690.0
      ],
      [
        1941.008056640625,
        1962.2213134765625,
        689.9999389648438
      ],
      [
        1959.039306640625,
        1951.96826171875,
        705.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        695.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        695.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        710.0
      ],
      [
        2036.821044921875,
        1874.1865234375,
        696.5
      ],
      [
        2029.75,
        1881.257568359375,
        696.5
      ],
      [
        2029.75,
        1881.257568359375,
        706.4874877929688
      ],
      [
        2036.821044921875,
        1874.1865234375,
        706.4874877929688
      ],
      [
        2036.821044921875,
        1874.1865234375,
        706.4874877929688
      ],
      [
        2036.821044921875,
        1874.1865234375,
        696.5
      ],
      [
        2029.75,
        1881.257568359375,
        696.5
      ],
      [
        2029.75,
        1881.257568359375,
        706.4874877929688
      ],
      [
        1951.96826171875,
        1959.039306640625,
        695.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        705.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        705.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        705.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        695.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        710.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        687.4999389648438
      ],
      [
        2011.71875,
        1884.4395751953125,
        687.5
      ],
      [
        1962.2213134765625,
        1933.93701171875,
        687.5
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        687.4999389648438
      ],
      [
        1955.1502685546875,
        1948.0792236328125,
        674.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        674.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        670.0
      ],
      [
        1941.008056640625,
        1962.2213134765625,
        674.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        670.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        674.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        680.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        680.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        680.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        680.0
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        692.75
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        690.0
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        690.0
      ],
      [
        2026.2144775390625,
        1884.7930908203125,
        670.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        680.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        680.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        680.0
      ],
      [
        1944.897216796875,
        1966.1103515625,
        680.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        690.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        692.75
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        680.0
      ],
      [
        1962.5748291015625,
        1948.4327392578125,
        690.0
      ],
      [
        1944.897216796875,
        1966.1103515625,
        680.0
      ],
      [
        1944.897216796875,
        1966.1103515625,
        670.0
      ],
      [
        1930.4014892578125,
        1923.3304443359375,
        674.0
      ],
      [
        1951.61474609375,
        1944.543701171875,
        674.0
      ],
      [
        1916.2593994140625,
        1937.4725341796875,
        674.0
      ],
      [
        1937.4725341796875,
        1958.685791015625,
        674.0
      ],
      [
        1930.4014892578125,
        1923.3304443359375,
        674.0
      ],
      [
        1916.2593994140625,
        1937.4725341796875,
        674.0
      ],
      [
        1939.82958984375,
        1946.900634765625,
        674.0
      ],
      [
        1932.758544921875,
        1953.9718017578125,
        674.0
      ],
      [
        1933.7012939453125,
        1954.91455078125,
        674.0
      ],
      [
        1940.7724609375,
        1947.843505859375,
        674.0
      ],
      [
        1940.7724609375,
        1947.843505859375,
        674.0
      ],
      [
        1939.82958984375,
        1946.900634765625,
        674.0
      ],
      [
        1930.900634765625,
        1937.9716796875,
        684.4706420898438
      ],
      [
        1930.900634765625,
        1937.9716796875,
        684.4706420898438
      ],
      [
        1937.9716796875,
        1930.900634765625,
        684.4706420898438
      ],
      [
        1949.1397705078125,
        1942.0687255859375,
        695.0
      ],
      [
        1943.1292724609375,
        1948.0792236328125,
        695.0
      ],
      [
        1942.0687255859375,
        1949.1397705078125,
        695.0
      ],
      [
        1943.1292724609375,
        1948.0792236328125,
        695.0
      ],
      [
        1934.99755859375,
        1956.2108154296875,
        695.0
      ],
      [
        2000.68798828125,
        1848.8013916015625,
        720.0
      ],
      [
        2000.68798828125,
        1848.8013916015625,
        718.0
      ],
      [
        2004.2235107421875,
        1845.265869140625,
        718.0
      ],
      [
        2004.2235107421875,
        1845.265869140625,
        720.0
      ],
      [
        2000.68798828125,
        1848.8013916015625,
        718.0
      ],
      [
        2000.68798828125,
        1848.8013916015625,
        720.0
      ],
      [
        1999.273681640625,
        1847.38720703125,
        720.0
      ],
      [
        1999.273681640625,
        1847.38720703125,
        718.0
      ],
      [
        2002.8092041015625,
        1843.8516845703125,
        718.0
      ],
      [
        2002.8092041015625,
        1843.8516845703125,
        720.0
      ],
      [
        2004.2235107421875,
        1845.265869140625,
        720.0
      ],
      [
        2004.2235107421875,
        1845.265869140625,
        718.0
      ],
      [
        2039.7584228515625,
        1871.2491455078125,
        650.0
      ],
      [
        2039.7584228515625,
        1871.2491455078125,
        665.0
      ],
      [
        1947.6165771484375,
        1963.390869140625,
        665.0
      ],
      [
        1947.6165771484375,
        1963.390869140625,
        650.0
      ],
      [
        2004.2943115234375,
        1906.713623046875,
        650.6016845703125
      ],
      [
        2004.2943115234375,
        1906.713623046875,
        650.0
      ],
      [
        2029.15185546875,
        1881.855712890625,
        650.600341796875
      ],
      [
        2029.15185546875,
        1881.855712890625,
        650.0
      ],
      [
        2029.15185546875,
        1881.855712890625,
        650.600341796875
      ],
      [
        2029.7177734375,
        1881.2899169921875,
        650.6015014648438
      ],
      [
        2029.859619140625,
        1881.14794921875,
        650.6014404296875
      ],
      [
        2029.7177734375,
        1881.2899169921875,
        650.6015014648438
      ],
      [
        2029.859619140625,
        1881.14794921875,
        650.6014404296875
      ],
      [
        2029.859619140625,
        1881.14794921875,
        650.0
      ],
      [
        2005.001220703125,
        1906.00634765625,
        650.6002807617188
      ],
      [
        2004.8597412109375,
        1906.1478271484375,
        650.6002807617188
      ],
      [
        2004.2943115234375,
        1906.713623046875,
        650.6016845703125
      ],
      [
        2004.8597412109375,
        1906.1478271484375,
        650.6002807617188
      ],
      [
        2005.001220703125,
        1906.00634765625,
        650.6002807617188
      ],
      [
        2005.001220703125,
        1906.00634765625,
        650.0
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        650.0
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        650.6002807617188
      ],
      [
        1958.2232666015625,
        1952.7843017578125,
        650.6002807617188
      ],
      [
        1957.657470703125,
        1953.3502197265625,
        650.6014404296875
      ],
      [
        1957.515625,
        1953.4921875,
        650.6015014648438
      ],
      [
        1957.657470703125,
        1953.3502197265625,
        650.6014404296875
      ],
      [
        1957.5155029296875,
        1953.4920654296875,
        650.0
      ],
      [
        1957.515625,
        1953.4921875,
        650.6015014648438
      ],
      [
        1983.7880859375,
        1927.219482421875,
        650.5999755859375
      ],
      [
        1984.4951171875,
        1926.5123291015625,
        650.5999755859375
      ],
      [
        1983.7880859375,
        1927.219482421875,
        650.0
      ],
      [
        1983.7880859375,
        1927.219482421875,
        650.5999755859375
      ],
      [
        1984.4951171875,
        1926.5123291015625,
        650.5999755859375
      ],
      [
        1984.4951171875,
        1926.5123291015625,
        650.0
      ],
      [
        2039.18701171875,
        2054.961181640625,
        683.1578979492188
      ],
      [
        2131.328857421875,
        1962.8194580078125,
        683.1578979492188
      ],
      [
        2114.046630859375,
        1938.6846923828125,
        385.0
      ],
      [
        2106.470947265625,
        1931.1087646484375,
        385.0
      ],
      [
        2120.613037109375,
        1945.2510986328125,
        385.0
      ],
      [
        2114.046630859375,
        1938.6846923828125,
        385.0
      ],
      [
        2096.571533203125,
        1941.0081787109375,
        668.0
      ],
      [
        2103.044677734375,
        1934.53515625,
        668.0
      ],
      [
        2010.9027099609375,
        2026.677001953125,
        668.0
      ],
      [
        2018.08251953125,
        2019.496826171875,
        667.9998779296875
      ],
      [
        2032.224853515625,
        2005.354736328125,
        410.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        410.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        410.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        405.0
      ],
      [
        2081.72216796875,
        1955.8572998046875,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        410.0
      ],
      [
        2085.258056640625,
        1952.32177734375,
        405.0
      ],
      [
        2032.224853515625,
        2005.354736328125,
        410.0
      ],
      [
        2032.224853515625,
        2005.354736328125,
        405.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        405.0
      ],
      [
        2028.689208984375,
        2008.8902587890625,
        410.0
      ],
      [
        2017.9737548828125,
        2019.60595703125,
        640.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2096.6806640625,
        1940.899169921875,
        640.0
      ],
      [
        2017.9737548828125,
        2019.60595703125,
        645.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      [
        2096.6806640625,
        1940.899169921875,
        645.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      [
        2025.044677734375,
        2012.53466796875,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      [
        2018.08251953125,
        2019.496826171875,
        667.9998779296875
      ],
      [
        2025.1536865234375,
        2026.5679931640625,
        680.0
      ],
      [
        2019.436767578125,
        2020.85107421875,
        679.14892578125
      ],
      [
        2018.0826416015625,
        2019.4969482421875,
        677.9998779296875
      ],
      [
        2096.571533203125,
        1941.008056640625,
        678.0
      ],
      [
        2097.925537109375,
        1942.362060546875,
        679.1488647460938
      ],
      [
        2103.642822265625,
        1948.0792236328125,
        680.0
      ],
      [
        2096.571533203125,
        1941.0081787109375,
        668.0
      ],
      [
        2103.044677734375,
        1934.53515625,
        668.0
      ],
      [
        2110.11572265625,
        1941.6060791015625,
        680.0
      ],
      [
        2104.398681640625,
        1935.88916015625,
        679.14892578125
      ],
      [
        2103.04443359375,
        1934.5350341796875,
        677.9998779296875
      ],
      [
        2103.04443359375,
        1934.5350341796875,
        677.9998779296875
      ],
      [
        2104.398681640625,
        1935.88916015625,
        679.14892578125
      ],
      [
        2097.925537109375,
        1942.3621826171875,
        679.14892578125
      ],
      [
        2096.5712890625,
        1941.008056640625,
        677.9998779296875
      ],
      [
        2010.902587890625,
        2026.6768798828125,
        677.9998779296875
      ],
      [
        2012.2567138671875,
        2028.031005859375,
        679.14892578125
      ],
      [
        2017.9736328125,
        2033.7479248046875,
        680.0
      ],
      [
        2010.9027099609375,
        2026.677001953125,
        668.0
      ],
      [
        2018.0826416015625,
        2019.4969482421875,
        677.9998779296875
      ],
      [
        2019.436767578125,
        2020.85107421875,
        679.14892578125
      ],
      [
        2012.2567138671875,
        2028.031005859375,
        679.14892578125
      ],
      [
        2010.902587890625,
        2026.6768798828125,
        677.9998779296875
      ],
      [
        2103.642578125,
        1962.2213134765625,
        681.0526123046875
      ],
      [
        2110.713623046875,
        1955.1502685546875,
        681.0526733398438
      ],
      [
        2032.224853515625,
        2033.63916015625,
        681.0526733398438
      ],
      [
        2040.0030517578125,
        2025.8609619140625,
        681.0526733398438
      ],
      [
        2075.3583984375,
        1990.505615234375,
        681.0526733398438
      ],
      [
        2096.571533203125,
        1969.2923583984375,
        681.0526733398438
      ],
      [
        2068.287353515625,
        1997.57666015625,
        681.0526733398438
      ],
      [
        2047.0740966796875,
        2018.7899169921875,
        681.0526733398438
      ],
      [
        2068.287353515625,
        1997.57666015625,
        681.0526733398438
      ],
      [
        2032.224853515625,
        2033.63916015625,
        681.0526733398438
      ],
      [
        2047.0740966796875,
        2018.7899169921875,
        681.0526733398438
      ],
      [
        2040.0030517578125,
        2025.8609619140625,
        681.0526733398438
      ],
      [
        2025.0447998046875,
        2040.819091796875,
        681.0526733398438
      ],
      [
        2103.642578125,
        1962.2213134765625,
        681.0526733398438
      ],
      [
        2117.186767578125,
        1948.67724609375,
        681.0526733398438
      ],
      [
        2110.713623046875,
        1955.1502685546875,
        681.0526733398438
      ],
      [
        2096.571533203125,
        1969.2923583984375,
        681.0526733398438
      ],
      [
        2075.3583984375,
        1990.505615234375,
        681.0526733398438
      ],
      [
        2131.328857421875,
        1962.8194580078125,
        683.1578979492188
      ],
      [
        2117.186767578125,
        1948.67724609375,
        681.0526733398438
      ],
      [
        2025.0447998046875,
        2040.819091796875,
        681.0526733398438
      ],
      [
        2039.18701171875,
        2054.961181640625,
        683.1578979492188
      ],
      [
        2078.186767578125,
        1902.824462890625,
        370.0
      ],
      [
        2043.1851806640625,
        1867.8223876953125,
        370.0
      ],
      [
        1982.6182861328125,
        1998.392578125,
        650.0
      ],
      [
        1989.7984619140625,
        1991.212646484375,
        650.0
      ],
      [
        1989.7984619140625,
        1991.212646484375,
        660.0
      ],
      [
        1982.6182861328125,
        1998.392578125,
        660.0
      ],
      [
        1989.7984619140625,
        1991.212646484375,
        650.0
      ],
      [
        1989.7984619140625,
        1991.212646484375,
        660.0
      ],
      [
        1982.6182861328125,
        1998.392578125,
        660.0
      ],
      [
        1982.6182861328125,
        1998.392578125,
        650.0
      ],
      [
        2074.76025390625,
        1906.2509765625,
        650.0
      ],
      [
        2074.76025390625,
        1906.2509765625,
        660.0
      ],
      [
        2068.287353515625,
        1912.723876953125,
        660.0
      ],
      [
        2068.287353515625,
        1912.723876953125,
        650.0
      ],
      [
        2068.287353515625,
        1912.723876953125,
        650.0
      ],
      [
        2074.76025390625,
        1906.2509765625,
        650.0
      ],
      [
        2074.76025390625,
        1906.2509765625,
        660.0
      ],
      [
        2068.287353515625,
        1912.723876953125,
        660.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        635.0
      ],
      [
        2074.651123046875,
        1899.288818359375,
        635.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        653.0
      ],
      [
        2074.651123046875,
        1899.288818359375,
        653.0
      ],
      [
        2074.651123046875,
        1899.288818359375,
        653.0
      ],
      [
        2074.651123046875,
        1899.288818359375,
        635.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        648.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        635.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        653.0
      ],
      [
        2056.9736328125,
        1881.6112060546875,
        648.0
      ],
      [
        2046.47607421875,
        1899.179931640625,
        650.0
      ],
      [
        2021.617431640625,
        1922.6224365234375,
        653.0
      ],
      [
        2021.617431640625,
        1922.6224365234375,
        650.0
      ],
      [
        2000.4041748046875,
        1943.835693359375,
        650.0
      ],
      [
        2000.4041748046875,
        1943.8355712890625,
        653.0
      ],
      [
        2087.1435546875,
        1931.580078125,
        660.0
      ],
      [
        2001.474609375,
        2017.2489013671875,
        660.0
      ],
      [
        2008.654541015625,
        2010.06884765625,
        660.0
      ],
      [
        2001.474609375,
        2017.2489013671875,
        660.0
      ],
      [
        2008.654541015625,
        2010.06884765625,
        660.0
      ],
      [
        2093.616455078125,
        1925.1070556640625,
        660.0
      ],
      [
        2087.1435546875,
        1931.580078125,
        660.0
      ],
      [
        2093.616455078125,
        1925.1070556640625,
        660.0
      ],
      [
        2079.0029296875,
        1923.221435546875,
        370.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        370.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        370.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        385.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        650.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        660.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        413.75
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        470.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        590.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        650.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        530.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        590.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        470.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        530.0
      ],
      [
        1981.3131103515625,
        2020.9111328125,
        385.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        385.0
      ],
      [
        1993.22509765625,
        2008.999267578125,
        653.0
      ],
      [
        2008.5455322265625,
        2010.1778564453125,
        660.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        653.0
      ],
      [
        1993.22509765625,
        2008.999267578125,
        660.0
      ],
      [
        1993.22509765625,
        2008.999267578125,
        653.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        645.0
      ],
      [
        2007.3671875,
        1994.857177734375,
        645.0
      ],
      [
        2000.2960205078125,
        2001.92822265625,
        640.0
      ],
      [
        2007.3671875,
        1994.857177734375,
        640.0
      ],
      [
        2007.3671875,
        1994.857177734375,
        645.0
      ],
      [
        2007.3671875,
        1994.857177734375,
        640.0
      ],
      [
        2000.405029296875,
        2001.8193359375,
        653.0
      ],
      [
        2000.405029296875,
        2001.8193359375,
        653.0
      ],
      [
        2000.405029296875,
        2001.8193359375,
        660.0
      ],
      [
        2079.0029296875,
        1923.221435546875,
        385.0
      ],
      [
        2079.0029296875,
        1923.221435546875,
        370.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        650.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        660.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        413.75
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        470.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        590.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        650.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        530.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        590.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        470.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        530.0
      ],
      [
        2079.0029296875,
        1923.221435546875,
        385.0
      ],
      [
        2088.79345703125,
        1913.4310302734375,
        385.0
      ],
      [
        2087.25244140625,
        1931.47119140625,
        660.0
      ],
      [
        2085.366943359375,
        1916.8575439453125,
        653.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        653.0
      ],
      [
        2085.366943359375,
        1916.8575439453125,
        653.0
      ],
      [
        2085.366943359375,
        1916.8575439453125,
        660.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        645.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        645.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        640.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      [
        2071.224609375,
        1930.999755859375,
        645.0
      ],
      [
        2078.89404296875,
        1923.3304443359375,
        653.0
      ],
      [
        2078.89404296875,
        1923.3304443359375,
        660.0
      ],
      [
        2078.89404296875,
        1923.3304443359375,
        653.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        470.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        470.0
      ],
      [
        2043.53857421875,
        1958.685791015625,
        370.84906005859375
      ],
      [
        2048.488525390625,
        1953.736083984375,
        370.84906005859375
      ],
      [
        2030.1036376953125,
        1972.120849609375,
        370.84906005859375
      ],
      [
        2035.0533447265625,
        1967.1710205078125,
        370.84906005859375
      ],
      [
        2035.0533447265625,
        1967.1710205078125,
        374.34906005859375
      ],
      [
        2035.0533447265625,
        1967.1710205078125,
        370.84906005859375
      ],
      [
        2049.1953125,
        1953.0289306640625,
        370.84906005859375
      ],
      [
        2049.1953125,
        1953.0289306640625,
        374.34906005859375
      ],
      [
        2049.1953125,
        1953.0289306640625,
        374.34906005859375
      ],
      [
        2048.488525390625,
        1953.736083984375,
        374.34906005859375
      ],
      [
        2035.7603759765625,
        1966.4639892578125,
        374.34906005859375
      ],
      [
        2035.0533447265625,
        1967.1710205078125,
        374.34906005859375
      ],
      [
        2029.396484375,
        1972.827880859375,
        374.34906005859375
      ],
      [
        2029.396484375,
        1972.827880859375,
        370.84906005859375
      ],
      [
        2030.1036376953125,
        1972.120849609375,
        374.34906005859375
      ],
      [
        2029.396484375,
        1972.827880859375,
        374.34906005859375
      ],
      [
        2032.224853515625,
        1969.99951171875,
        590.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        590.0
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        530.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        530.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        530.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        530.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        515.625
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        530.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        530.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        515.625
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        515.625
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        530.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        530.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        515.625
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        590.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        575.625
      ],
      [
        2032.224853515625,
        1969.99951171875,
        575.625
      ],
      [
        2032.224853515625,
        1969.99951171875,
        590.0
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        635.625
      ],
      [
        2032.224853515625,
        1969.99951171875,
        635.625
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        635.625
      ],
      [
        2056.9736328125,
        1945.250732421875,
        635.625
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        650.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        650.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        650.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        650.0
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        635.625
      ],
      [
        2046.366943359375,
        1955.8572998046875,
        650.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        650.0
      ],
      [
        2056.9736328125,
        1945.250732421875,
        635.625
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        635.625
      ],
      [
        2021.6182861328125,
        1980.6060791015625,
        650.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        650.0
      ],
      [
        2032.224853515625,
        1969.99951171875,
        635.625
      ],
      [
        2078.186767578125,
        1902.824462890625,
        385.0
      ],
      [
        2075.46728515625,
        1919.68603515625,
        650.0
      ],
      [
        2068.396240234375,
        1912.614990234375,
        650.0
      ],
      [
        2075.46728515625,
        1919.68603515625,
        650.0
      ],
      [
        2079.0029296875,
        1923.2215576171875,
        653.0
      ],
      [
        1996.760498046875,
        1998.392822265625,
        650.0
      ],
      [
        1989.6893310546875,
        1991.32177734375,
        650.0
      ],
      [
        1996.760498046875,
        1998.392822265625,
        650.0
      ],
      [
        2000.296142578125,
        2001.92822265625,
        653.0
      ],
      [
        2075.46728515625,
        1919.6859130859375,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      [
        2060.6181640625,
        1920.39306640625,
        382.0
      ],
      [
        1996.7606201171875,
        1998.3927001953125,
        382.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      [
        1996.7606201171875,
        1984.2506103515625,
        382.0
      ],
      [
        2036.821044921875,
        1874.1865234375,
        700.5123291015625
      ],
      [
        2029.75,
        1881.257568359375,
        700.5123291015625
      ],
      [
        1951.96826171875,
        1959.039306640625,
        700.5123901367188
      ],
      [
        1959.039306640625,
        1951.96826171875,
        700.5123901367188
      ],
      [
        2037.944580078125,
        1924.8074951171875,
        737.0
      ],
      [
        2002.58935546875,
        1960.1629638671875,
        737.0
      ],
      [
        2032.9150390625,
        1905.7286376953125,
        720.0
      ],
      [
        2032.96142578125,
        1905.6822509765625,
        720.0
      ],
      [
        1983.4639892578125,
        1955.1796875,
        720.0
      ],
      [
        1983.5103759765625,
        1955.13330078125,
        720.0
      ],
      [
        2008.2127685546875,
        1930.4310302734375,
        720.0
      ],
      [
        2032.9150390625,
        1905.7286376953125,
        720.0
      ],
      [
        1983.5103759765625,
        1955.13330078125,
        720.0
      ],
      [
        2008.2127685546875,
        1930.4310302734375,
        720.0
      ],
      [
        2041.4703369140625,
        1914.191162109375,
        732.0
      ],
      [
        2032.96142578125,
        1905.6822509765625,
        720.0
      ],
      [
        1983.4639892578125,
        1955.1796875,
        720.0
      ],
      [
        1991.972900390625,
        1963.6885986328125,
        732.0
      ],
      [
        1991.972900390625,
        1963.6885986328125,
        732.0
      ],
      [
        2002.58935546875,
        1960.1629638671875,
        737.0
      ],
      [
        2041.4703369140625,
        1914.191162109375,
        732.0
      ],
      [
        2037.944580078125,
        1924.8074951171875,
        737.0
      ],
      [
        2029.396484375,
        1887.97509765625,
        700.0
      ],
      [
        2032.9320068359375,
        1884.4395751953125,
        700.0
      ],
      [
        1962.2213134765625,
        1955.1502685546875,
        700.0
      ],
      [
        1965.7568359375,
        1951.61474609375,
        700.0
      ],
      [
        2029.396484375,
        1887.97509765625,
        700.0
      ],
      [
        1965.7568359375,
        1951.61474609375,
        700.0
      ],
      [
        2032.9320068359375,
        1884.4395751953125,
        700.0
      ],
      [
        2029.75,
        1881.257568359375,
        700.0
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        700.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        700.0
      ],
      [
        1962.2213134765625,
        1955.1502685546875,
        700.0
      ],
      [
        1959.039306640625,
        1951.96826171875,
        700.0
      ],
      [
        2040.0030517578125,
        1877.3685302734375,
        700.0
      ],
      [
        2036.821044921875,
        1874.1865234375,
        700.0
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        700.0
      ],
      [
        2004.647705078125,
        2011.71875,
        700.0
      ],
      [
        2089.50048828125,
        1926.865966796875,
        700.0
      ],
      [
        2040.0030517578125,
        1877.3685302734375,
        700.0
      ],
      [
        2091.268310546875,
        1995.8089599609375,
        720.0
      ],
      [
        2098.33935546875,
        2002.8800048828125,
        720.0
      ],
      [
        2091.268310546875,
        1995.8089599609375,
        720.0
      ],
      [
        2098.33935546875,
        2002.8800048828125,
        720.0
      ],
      [
        2082.429443359375,
        1955.1502685546875,
        724.4998779296875
      ],
      [
        2061.21630859375,
        1976.3634033203125,
        724.4998779296875
      ],
      [
        2054.145263671875,
        1983.4345703125,
        724.4998779296875
      ],
      [
        2061.21630859375,
        1976.3634033203125,
        724.4998779296875
      ],
      [
        2060.509033203125,
        1989.7982177734375,
        720.0
      ],
      [
        2054.145263671875,
        1983.4345703125,
        724.4998779296875
      ],
      [
        2015.2542724609375,
        2001.1121826171875,
        700.0
      ],
      [
        2015.2542724609375,
        2001.1121826171875,
        700.0
      ],
      [
        2004.647705078125,
        2011.71875,
        700.0
      ],
      [
        2078.89404296875,
        1937.4725341796875,
        700.0
      ],
      [
        2078.89404296875,
        1937.4725341796875,
        700.0
      ],
      [
        2089.50048828125,
        1926.865966796875,
        700.0
      ],
      [
        2073.590576171875,
        2013.486572265625,
        706.666748046875
      ],
      [
        2080.66162109375,
        2020.5576171875,
        706.6666870117188
      ],
      [
        2054.145263671875,
        1994.0411376953125,
        700.0
      ],
      [
        2071.82275390625,
        1976.363525390625,
        700.0
      ],
      [
        2054.145263671875,
        1994.0411376953125,
        700.0
      ],
      [
        2071.82275390625,
        1976.363525390625,
        700.0
      ],
      [
        2083.84375,
        1977.7777099609375,
        700.0
      ],
      [
        2094.4501953125,
        1967.171142578125,
        700.0
      ],
      [
        2091.621826171875,
        1964.3426513671875,
        700.0
      ],
      [
        2081.01513671875,
        1974.9493408203125,
        700.0
      ],
      [
        2083.631591796875,
        1977.5655517578125,
        700.0
      ],
      [
        2083.048095703125,
        1976.9820556640625,
        700.0
      ],
      [
        2083.84375,
        1977.7777099609375,
        700.0
      ],
      [
        2083.631591796875,
        1977.5655517578125,
        700.0
      ],
      [
        2094.238037109375,
        1966.958984375,
        700.0
      ],
      [
        2093.65478515625,
        1966.3756103515625,
        700.0
      ],
      [
        2094.4501953125,
        1967.171142578125,
        700.0
      ],
      [
        2094.238037109375,
        1966.958984375,
        700.0
      ],
      [
        2091.621826171875,
        1964.3426513671875,
        700.0
      ],
      [
        2081.01513671875,
        1974.9493408203125,
        700.0
      ],
      [
        2044.9527587890625,
        2016.6685791015625,
        700.0
      ],
      [
        2055.559326171875,
        2006.06201171875,
        700.0
      ],
      [
        2052.73095703125,
        2003.2335205078125,
        700.0
      ],
      [
        2042.1243896484375,
        2013.840087890625,
        700.0
      ],
      [
        2055.34716796875,
        2005.849853515625,
        700.0
      ],
      [
        2054.763916015625,
        2005.2664794921875,
        700.0
      ],
      [
        2055.559326171875,
        2006.06201171875,
        700.0
      ],
      [
        2055.34716796875,
        2005.849853515625,
        700.0
      ],
      [
        2044.7406005859375,
        2016.4564208984375,
        700.0
      ],
      [
        2044.1572265625,
        2015.873046875,
        700.0
      ],
      [
        2044.9527587890625,
        2016.6685791015625,
        700.0
      ],
      [
        2044.7406005859375,
        2016.4564208984375,
        700.0
      ],
      [
        2052.73095703125,
        2003.2335205078125,
        700.0
      ],
      [
        2042.1243896484375,
        2013.840087890625,
        700.0
      ],
      [
        2053.880126953125,
        1986.704833984375,
        700.0
      ],
      [
        2064.486572265625,
        1976.0982666015625,
        700.0
      ],
      [
        2034.4345703125,
        2006.1502685546875,
        700.0
      ],
      [
        2045.0411376953125,
        1995.543701171875,
        700.0
      ],
      [
        2073.325439453125,
        1967.2593994140625,
        700.0
      ],
      [
        2083.93212890625,
        1956.65283203125,
        700.0
      ],
      [
        2035.0533447265625,
        2006.76904296875,
        700.0
      ],
      [
        2045.659912109375,
        1996.1624755859375,
        700.0
      ],
      [
        2073.944091796875,
        1967.878173828125,
        700.0
      ],
      [
        2084.55078125,
        1957.2716064453125,
        700.0
      ],
      [
        2054.498779296875,
        1987.3236083984375,
        700.0
      ],
      [
        2065.10546875,
        1976.7169189453125,
        700.0
      ],
      [
        2064.486572265625,
        1976.0982666015625,
        700.0
      ],
      [
        2064.574951171875,
        1976.1866455078125,
        700.0
      ],
      [
        2064.574951171875,
        1976.1866455078125,
        700.0
      ],
      [
        2065.10546875,
        1976.7169189453125,
        700.0
      ],
      [
        2045.0411376953125,
        1995.543701171875,
        700.0
      ],
      [
        2045.659912109375,
        1996.1624755859375,
        700.0
      ],
      [
        2035.0533447265625,
        2006.76904296875,
        700.0
      ],
      [
        2034.4345703125,
        2006.1502685546875,
        700.0
      ],
      [
        2054.498779296875,
        1987.3236083984375,
        700.0
      ],
      [
        2053.880126953125,
        1986.704833984375,
        700.0
      ],
      [
        2083.93212890625,
        1956.65283203125,
        700.0
      ],
      [
        2084.55078125,
        1957.2716064453125,
        700.0
      ],
      [
        2073.944091796875,
        1967.878173828125,
        700.0
      ],
      [
        2073.325439453125,
        1967.2593994140625,
        700.0
      ],
      [
        2044.1573486328125,
        1976.982177734375,
        700.0
      ],
      [
        2054.763916015625,
        1966.3756103515625,
        700.0
      ],
      [
        2063.602783203125,
        1957.5367431640625,
        700.0
      ],
      [
        2074.20947265625,
        1946.9300537109375,
        700.0
      ],
      [
        2024.7119140625,
        1996.4276123046875,
        700.0
      ],
      [
        2035.3184814453125,
        1985.821044921875,
        700.0
      ],
      [
        2044.5992431640625,
        1977.424072265625,
        700.0
      ],
      [
        2055.205810546875,
        1966.8175048828125,
        700.0
      ],
      [
        2025.15380859375,
        1996.8695068359375,
        700.0
      ],
      [
        2035.7603759765625,
        1986.262939453125,
        700.0
      ],
      [
        2064.044677734375,
        1957.9786376953125,
        700.0
      ],
      [
        2074.6513671875,
        1947.3720703125,
        700.0
      ],
      [
        2054.763916015625,
        1966.3756103515625,
        700.0
      ],
      [
        2055.205810546875,
        1966.8175048828125,
        700.0
      ],
      [
        2035.3184814453125,
        1985.821044921875,
        700.0
      ],
      [
        2035.7603759765625,
        1986.262939453125,
        700.0
      ],
      [
        2025.15380859375,
        1996.8695068359375,
        700.0
      ],
      [
        2024.7119140625,
        1996.4276123046875,
        700.0
      ],
      [
        2044.5992431640625,
        1977.424072265625,
        700.0
      ],
      [
        2044.1573486328125,
        1976.982177734375,
        700.0
      ],
      [
        2074.20947265625,
        1946.9300537109375,
        700.0
      ],
      [
        2074.6513671875,
        1947.3720703125,
        700.0
      ],
      [
        2064.044677734375,
        1957.9786376953125,
        700.0
      ],
      [
        2063.602783203125,
        1957.5367431640625,
        700.0
      ],
      [
        2033.845947265625,
        2019.703857421875,
        680.1360473632812
      ],
      [
        2037.931884765625,
        2023.789794921875,
        690.0
      ],
      [
        2026.2027587890625,
        2033.2738037109375,
        687.2899780273438
      ],
      [
        2021.85107421875,
        2037.6253662109375,
        687.2900390625
      ],
      [
        2016.6083984375,
        2023.679443359375,
        679.14892578125
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        670.0
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        680.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        670.0
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        670.0
      ],
      [
        1955.1502685546875,
        1962.2213134765625,
        680.0
      ],
      [
        1951.96826171875,
        1959.039306640625,
        680.0
      ],
      [
        2021.85107421875,
        2037.6253662109375,
        687.2900390625
      ],
      [
        2018.8876953125,
        2034.6619873046875,
        680.1361083984375
      ],
      [
        2008.890380859375,
        1994.7481689453125,
        695.0
      ],
      [
        2029.0311279296875,
        2030.4454345703125,
        687.2899780273438
      ],
      [
        2029.0311279296875,
        2030.4454345703125,
        687.2900390625
      ],
      [
        2026.0677490234375,
        2027.4820556640625,
        680.1361083984375
      ],
      [
        2008.890380859375,
        1994.7481689453125,
        698.0
      ],
      [
        2008.890380859375,
        1994.7481689453125,
        695.0
      ],
      [
        2008.890380859375,
        1994.7481689453125,
        698.0
      ],
      [
        1965.0498046875,
        1952.32177734375,
        695.0
      ],
      [
        1965.7568359375,
        1951.61474609375,
        698.0
      ],
      [
        1965.0498046875,
        1952.32177734375,
        698.0
      ],
      [
        2015.2542724609375,
        2001.1121826171875,
        698.0
      ],
      [
        2014.547119140625,
        2001.8193359375,
        695.0
      ],
      [
        2014.547119140625,
        2001.8193359375,
        698.0
      ],
      [
        2014.547119140625,
        2001.8193359375,
        700.0
      ],
      [
        1965.0498046875,
        1952.32177734375,
        700.0
      ],
      [
        2101.571533203125,
        1960.150146484375,
        690.0
      ],
      [
        2097.4853515625,
        1956.064208984375,
        680.1360473632812
      ],
      [
        2113.992919921875,
        1945.4835205078125,
        687.2899780273438
      ],
      [
        2111.055419921875,
        1948.4208984375,
        687.2899780273438
      ],
      [
        2101.461181640625,
        1938.82666015625,
        679.14892578125
      ],
      [
        2113.9931640625,
        1945.4835205078125,
        687.2900390625
      ],
      [
        2111.02978515625,
        1942.5201416015625,
        680.1361083984375
      ],
      [
        2072.530029296875,
        1931.108642578125,
        695.0
      ],
      [
        2107.519775390625,
        1951.95654296875,
        687.2899780273438
      ],
      [
        2107.52001953125,
        1951.95654296875,
        687.2900390625
      ],
      [
        2104.556640625,
        1948.9931640625,
        680.1360473632812
      ],
      [
        2072.530029296875,
        1931.108642578125,
        698.0
      ],
      [
        2072.530029296875,
        1931.108642578125,
        695.0
      ],
      [
        2072.530029296875,
        1931.108642578125,
        698.0
      ],
      [
        2029.396484375,
        1887.97509765625,
        698.0
      ],
      [
        2030.1036376953125,
        1887.2679443359375,
        695.0
      ],
      [
        2030.1036376953125,
        1887.2679443359375,
        698.0
      ],
      [
        2078.89404296875,
        1937.4725341796875,
        698.0
      ],
      [
        2079.60107421875,
        1936.7655029296875,
        698.0
      ],
      [
        2079.60107421875,
        1936.7655029296875,
        695.0
      ],
      [
        2030.1036376953125,
        1887.2679443359375,
        700.0
      ],
      [
        2079.60107421875,
        1936.7655029296875,
        700.0
      ],
      [
        2078.54052734375,
        1983.0811767578125,
        699.5714721679688
      ],
      [
        2075.7119140625,
        1980.2525634765625,
        699.0
      ],
      [
        2075.7119140625,
        1980.2525634765625,
        700.0
      ],
      [
        2078.54052734375,
        1983.0811767578125,
        700.0
      ],
      [
        2063.1962890625,
        1957.1302490234375,
        695.4000244140625
      ],
      [
        2073.802734375,
        1946.5235595703125,
        695.3999633789062
      ],
      [
        2054.357421875,
        1965.9691162109375,
        695.4000244140625
      ],
      [
        2034.9117431640625,
        1985.414306640625,
        695.3999633789062
      ],
      [
        2024.30517578125,
        1996.0208740234375,
        695.3999633789062
      ],
      [
        2045.659912109375,
        1996.1624755859375,
        699.0
      ],
      [
        2035.0533447265625,
        2006.76904296875,
        699.0
      ],
      [
        2054.498779296875,
        1987.3236083984375,
        699.0
      ],
      [
        2084.55078125,
        1957.2716064453125,
        699.0
      ],
      [
        2073.944091796875,
        1967.878173828125,
        699.0
      ],
      [
        2094.50048828125,
        1967.22119140625,
        690.0
      ],
      [
        2101.5712890625,
        1960.150146484375,
        690.0
      ],
      [
        2066.216064453125,
        1995.5054931640625,
        690.0
      ],
      [
        2073.287109375,
        1988.4344482421875,
        690.0
      ],
      [
        2037.931884765625,
        2023.789794921875,
        690.0
      ],
      [
        2045.0029296875,
        2016.71875,
        690.0
      ],
      [
        2062.130126953125,
        1991.4195556640625,
        680.1360473632812
      ],
      [
        2066.216064453125,
        1995.5054931640625,
        690.0
      ],
      [
        2045.0029296875,
        2016.71875,
        690.0
      ],
      [
        2040.9169921875,
        2012.6326904296875,
        680.1360473632812
      ],
      [
        2090.414306640625,
        1963.13525390625,
        680.1360473632812
      ],
      [
        2094.500244140625,
        1967.22119140625,
        690.0
      ],
      [
        2073.287109375,
        1988.4344482421875,
        690.0
      ],
      [
        2069.201171875,
        1984.3485107421875,
        680.1360473632812
      ],
      [
        2007.337158203125,
        1922.484375,
        670.9266967773438
      ],
      [
        2028.550537109375,
        1901.271240234375,
        670.9266967773438
      ],
      [
        1979.0528564453125,
        1950.7685546875,
        670.9266967773438
      ],
      [
        1979.887451171875,
        1951.6031494140625,
        671.0509033203125
      ],
      [
        1979.8875732421875,
        1951.603271484375,
        671.076171875
      ],
      [
        1979.8875732421875,
        1951.603271484375,
        671.076171875
      ],
      [
        2001.1007080078125,
        1930.3900146484375,
        671.076171875
      ],
      [
        2001.1005859375,
        1930.389892578125,
        671.0509033203125
      ],
      [
        2000.2659912109375,
        1929.5552978515625,
        670.9266967773438
      ],
      [
        2001.1007080078125,
        1930.3900146484375,
        671.076171875
      ],
      [
        2010.1632080078125,
        1939.4525146484375,
        672.4000244140625
      ],
      [
        1988.9500732421875,
        1960.665771484375,
        672.4000244140625
      ],
      [
        2017.234375,
        1932.381591796875,
        672.4000244140625
      ],
      [
        2038.447509765625,
        1911.1683349609375,
        672.4000244140625
      ],
      [
        2020.0601806640625,
        1949.349609375,
        673.873291015625
      ],
      [
        1998.8470458984375,
        1970.562744140625,
        673.873291015625
      ],
      [
        2048.344482421875,
        1921.065185546875,
        673.873291015625
      ],
      [
        2027.13134765625,
        1942.2784423828125,
        673.873291015625
      ],
      [
        2029.9571533203125,
        1959.2464599609375,
        675.3466186523438
      ],
      [
        2008.743896484375,
        1980.459716796875,
        675.3466186523438
      ],
      [
        2037.0283203125,
        1952.175537109375,
        675.3466796875
      ],
      [
        2058.24169921875,
        1930.96240234375,
        675.3466796875
      ],
      [
        2046.925537109375,
        1962.07275390625,
        676.8200073242188
      ],
      [
        2068.138916015625,
        1940.859619140625,
        676.8200073242188
      ],
      [
        2039.8546142578125,
        1969.1439208984375,
        676.8200073242188
      ],
      [
        2018.641357421875,
        1990.3570556640625,
        676.8200073242188
      ],
      [
        2049.75146484375,
        1979.040771484375,
        678.2933349609375
      ],
      [
        2028.5384521484375,
        2000.254150390625,
        678.2933349609375
      ],
      [
        2078.03564453125,
        1950.75634765625,
        678.2933349609375
      ],
      [
        2056.822509765625,
        1971.9697265625,
        678.2933349609375
      ],
      [
        2064.044677734375,
        1871.711669921875,
        370.0
      ],
      [
        2055.5595703125,
        1880.1968994140625,
        370.0
      ],
      [
        2065.33203125,
        1870.4241943359375,
        648.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2765.5,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        1135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        370.0
      ],
      "bbox_max": [
        2051.67041015625,
        1975.302734375,
        740.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2720.000244140625,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        649.7000122070312
      ],
      "bbox_max": [
        2039.7584228515625,
        1966.1103515625,
        740.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        649.7000122070312
      ],
      "bbox_max": [
        2039.7584228515625,
        1966.1103515625,
        740.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.36380255222320557,
        0.36380425095558167,
        0.8574930429458618
      ],
      "plane_d": -1979.9510498046875,
      "bbox_min": [
        1957.8697509765625,
        1881.502197265625,
        649.7000122070312
      ],
      "bbox_max": [
        2029.15185546875,
        1952.7843017578125,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        -5.7925312546558416e-08
      ],
      "plane_d": 40.009681701660156,
      "bbox_min": [
        1957.8697509765625,
        1881.502197265625,
        649.7000122070312
      ],
      "bbox_max": [
        2029.15185546875,
        1952.7843017578125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        2004.647705078125,
        1881.502197265625,
        649.7000122070312
      ],
      "bbox_max": [
        2029.15185546875,
        1906.00634765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071043252944946,
        -0.7071092128753662,
        0.0
      ],
      "plane_d": -69.990478515625,
      "bbox_min": [
        2004.647705078125,
        1905.65283203125,
        649.7000122070312
      ],
      "bbox_max": [
        2005.001220703125,
        1906.00634765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071094512939453,
        -0.7071041464805603,
        0.0
      ],
      "plane_d": -3.8563232421875,
      "bbox_min": [
        1957.8697509765625,
        1952.4307861328125,
        649.7000122070312
      ],
      "bbox_max": [
        1958.2232666015625,
        1952.7843017578125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        650.0
      ],
      "bbox_max": [
        2039.7584228515625,
        1966.1103515625,
        740.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        665.0
      ],
      "bbox_max": [
        2036.821044921875,
        1966.1103515625,
        740.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.5521588921546936,
        -0.5521652102470398,
        -0.6246872544288635
      ],
      "plane_d": 2562.8232421875,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 667.5,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 63.0,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 93.0,
      "bbox_min": [
        1996.1624755859375,
        1875.2471923828125,
        665.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1889.3892822265625,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        1996.1624755859375,
        1885.853759765625,
        665.0
      ],
      "bbox_max": [
        1999.697998046875,
        1889.3892822265625,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 33.0,
      "bbox_min": [
        1953.736083984375,
        1907.0670166015625,
        665.0
      ],
      "bbox_max": [
        1978.4847412109375,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -48.0,
      "bbox_min": [
        1974.94921875,
        1907.0670166015625,
        665.0
      ],
      "bbox_max": [
        1978.4847412109375,
        1910.6025390625,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -18.0001220703125,
      "bbox_min": [
        1953.736083984375,
        1928.2801513671875,
        665.0
      ],
      "bbox_max": [
        1957.2716064453125,
        1931.815673828125,
        667.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071061730384827,
        -0.7071074843406677,
        -0.0
      ],
      "plane_d": 2755.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        669.9999389648438
      ],
      "bbox_max": [
        2036.821044921875,
        1966.1103515625,
        740.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.31622859835624695,
        0.31622859835624695,
        -0.8944266438484192
      ],
      "plane_d": -617.1583862304688,
      "bbox_min": [
        1937.4725341796875,
        1866.761962890625,
        670.0
      ],
      "bbox_max": [
        2036.821044921875,
        1966.1103515625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        1937.4725341796875,
        1866.761962890625,
        687.4999389648438
      ],
      "bbox_max": [
        2036.821044921875,
        1962.2213134765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 710.0,
      "bbox_min": [
        1937.4725341796875,
        1866.761962890625,
        689.9999389648438
      ],
      "bbox_max": [
        2036.821044921875,
        1962.2213134765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        2004.647705078125,
        1884.4395751953125,
        720.0
      ],
      "bbox_max": [
        2019.1434326171875,
        1906.00634765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        2004.647705078125,
        1884.4395751953125,
        720.0
      ],
      "bbox_max": [
        2019.1434326171875,
        1906.00634765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071129083633423,
        0.7071006894111633,
        0.0
      ],
      "plane_d": -2765.000732421875,
      "bbox_min": [
        2004.647705078125,
        1898.5816650390625,
        720.0
      ],
      "bbox_max": [
        2012.072265625,
        1906.00634765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        2004.647705078125,
        1898.5816650390625,
        720.0
      ],
      "bbox_max": [
        2012.072265625,
        1906.00634765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 732.0,
      "bbox_min": [
        2004.647705078125,
        1898.5816650390625,
        720.0
      ],
      "bbox_max": [
        2012.072265625,
        1906.00634765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        2004.647705078125,
        1898.5816650390625,
        720.0
      ],
      "bbox_max": [
        2012.072265625,
        1906.00634765625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 732.0,
      "bbox_min": [
        2004.647705078125,
        1884.4395751953125,
        720.0
      ],
      "bbox_max": [
        2019.1434326171875,
        1898.9351806640625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        2004.647705078125,
        1884.4395751953125,
        720.0
      ],
      "bbox_max": [
        2019.1434326171875,
        1898.9351806640625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        1937.4725341796875,
        1866.761962890625,
        689.9999389648438
      ],
      "bbox_max": [
        2036.821044921875,
        1962.2213134765625,
        710.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        -0.7071098685264587,
        0.0
      ],
      "plane_d": 2760.000244140625,
      "bbox_min": [
        1937.4725341796875,
        1944.5435791015625,
        689.9999389648438
      ],
      "bbox_max": [
        1955.1502685546875,
        1962.2213134765625,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 694.0,
      "bbox_min": [
        1937.4725341796875,
        1944.5435791015625,
        689.9999389648438
      ],
      "bbox_max": [
        1955.1502685546875,
        1962.2213134765625,
        695.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1937.4725341796875,
        1944.543701171875,
        694.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1962.2213134765625,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071085572242737,
        -0.7071050405502319,
        0.0
      ],
      "plane_d": 14.9931640625,
      "bbox_min": [
        1937.4725341796875,
        1958.685791015625,
        689.9999389648438
      ],
      "bbox_max": [
        1941.008056640625,
        1962.2213134765625,
        694.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1937.4725341796875,
        1866.761962890625,
        695.0
      ],
      "bbox_max": [
        2036.821044921875,
        1962.2213134765625,
        710.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.22360748052597046,
        0.22360748052597046,
        0.9486830830574036
      ],
      "plane_d": -1535.288330078125,
      "bbox_min": [
        2022.325439453125,
        1866.761962890625,
        696.5
      ],
      "bbox_max": [
        2036.821044921875,
        1881.257568359375,
        709.9583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22192995250225067,
        -0.22192995250225067,
        -0.9494705200195312
      ],
      "plane_d": 1538.7587890625,
      "bbox_min": [
        2022.325439453125,
        1866.761962890625,
        696.5
      ],
      "bbox_max": [
        2036.821044921875,
        1881.257568359375,
        709.9583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        2022.325439453125,
        1866.761962890625,
        696.5
      ],
      "bbox_max": [
        2036.821044921875,
        1881.257568359375,
        709.9583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        2022.325439453125,
        1873.8330078125,
        696.5
      ],
      "bbox_max": [
        2029.75,
        1881.257568359375,
        709.9583740234375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        -0.7071129083633423,
        -0.0
      ],
      "plane_d": 2760.0,
      "bbox_min": [
        1937.4725341796875,
        1948.0792236328125,
        695.0
      ],
      "bbox_max": [
        1959.039306640625,
        1962.2213134765625,
        710.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1948.0792236328125,
        1948.0792236328125,
        695.0
      ],
      "bbox_max": [
        1959.039306640625,
        1959.039306640625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 705.0,
      "bbox_min": [
        1948.0792236328125,
        1948.0792236328125,
        705.0
      ],
      "bbox_max": [
        1959.039306640625,
        1959.039306640625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071085572242737,
        -0.7071050405502319,
        0.0
      ],
      "plane_d": 14.9931640625,
      "bbox_min": [
        1937.4725341796875,
        1958.685791015625,
        695.0
      ],
      "bbox_max": [
        1941.008056640625,
        1962.2213134765625,
        710.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -20.0001220703125,
      "bbox_min": [
        1962.2213134765625,
        1933.93701171875,
        687.5
      ],
      "bbox_max": [
        1965.7568359375,
        1937.4725341796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071085572242737,
        -0.7071050405502319,
        0.0
      ],
      "plane_d": 14.9931640625,
      "bbox_min": [
        1937.4725341796875,
        1958.685791015625,
        687.4999389648438
      ],
      "bbox_max": [
        1941.008056640625,
        1962.2213134765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        1937.4725341796875,
        1880.904052734375,
        670.0
      ],
      "bbox_max": [
        2026.2144775390625,
        1966.1103515625,
        692.75
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -674.0,
      "bbox_min": [
        1937.4725341796875,
        1884.4395751953125,
        670.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1962.2213134765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 89.9998779296875,
      "bbox_min": [
        2011.71875,
        1884.4395751953125,
        674.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1887.97509765625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1941.008056640625,
        1944.543701171875,
        670.0
      ],
      "bbox_max": [
        1962.5748291015625,
        1966.1103515625,
        692.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        1958.685791015625,
        1944.543701171875,
        680.0
      ],
      "bbox_max": [
        1962.5748291015625,
        1948.4327392578125,
        692.75
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": 15.0238037109375,
      "bbox_min": [
        1941.008056640625,
        1962.2213134765625,
        670.0
      ],
      "bbox_max": [
        1944.897216796875,
        1966.1103515625,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        669.9999389648438
      ],
      "bbox_max": [
        2029.396484375,
        1958.685791015625,
        740.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -674.0,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        669.9999389648438
      ],
      "bbox_max": [
        2029.396484375,
        1958.685791015625,
        740.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        669.9999389648438
      ],
      "bbox_max": [
        1951.61474609375,
        1958.685791015625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4242587983608246,
        -0.42426612973213196,
        -0.8000017404556274
      ],
      "plane_d": 2188.19482421875,
      "bbox_min": [
        1932.758544921875,
        1946.900634765625,
        669.9999389648438
      ],
      "bbox_max": [
        1944.543701171875,
        1958.685791015625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4242686331272125,
        0.42426130175590515,
        0.7999991178512573
      ],
      "plane_d": -2189.0029296875,
      "bbox_min": [
        1933.7012939453125,
        1946.900634765625,
        669.9999389648438
      ],
      "bbox_max": [
        1944.543701171875,
        1958.685791015625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 4.9998779296875,
      "bbox_min": [
        1939.82958984375,
        1946.900634765625,
        669.9999389648438
      ],
      "bbox_max": [
        1944.543701171875,
        1951.61474609375,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -9.9931640625,
      "bbox_min": [
        1916.2593994140625,
        1842.01318359375,
        674.0
      ],
      "bbox_max": [
        2029.396484375,
        1958.685791015625,
        740.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        1916.2593994140625,
        1916.2593994140625,
        674.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1958.685791015625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 710.0,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1951.61474609375,
        1958.685791015625,
        710.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1951.61474609375,
        1958.685791015625,
        710.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071085572242737,
        -0.7071050405502319,
        0.0
      ],
      "plane_d": 14.9931640625,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        710.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2725.0,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        710.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.4242686331272125,
        0.42426130175590515,
        0.7999991178512573
      ],
      "plane_d": -2189.0029296875,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -684.9999389648438,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1940.7724609375,
        1953.9718017578125,
        685.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.4242587983608246,
        -0.42426612973213196,
        -0.8000017404556274
      ],
      "plane_d": 2188.19482421875,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        674.0
      ],
      "bbox_max": [
        1940.7724609375,
        1953.9718017578125,
        685.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 4.9998779296875,
      "bbox_min": [
        1930.4014892578125,
        1930.4014892578125,
        674.0
      ],
      "bbox_max": [
        1940.7724609375,
        1947.843505859375,
        685.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3922315537929535,
        0.3922315537929535,
        -0.8320509195327759
      ],
      "plane_d": -947.9793701171875,
      "bbox_min": [
        1930.4014892578125,
        1930.4014892578125,
        684.0
      ],
      "bbox_max": [
        1937.9716796875,
        1937.9716796875,
        684.4706420898438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 683.9999389648438,
      "bbox_min": [
        1916.2593994140625,
        1923.3304443359375,
        684.0
      ],
      "bbox_max": [
        1937.4725341796875,
        1944.543701171875,
        684.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.3922315537929535,
        -0.3922315537929535,
        0.8320509195327759
      ],
      "plane_d": 947.1473388671875,
      "bbox_min": [
        1930.4014892578125,
        1930.4014892578125,
        684.4706420898438
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3922315537929535,
        0.3922315537929535,
        -0.8320509195327759
      ],
      "plane_d": -947.9793701171875,
      "bbox_min": [
        1930.4014892578125,
        1930.900634765625,
        684.4706420898438
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        0.7071026563644409,
        0.0
      ],
      "plane_d": -4.984130859375,
      "bbox_min": [
        1930.4014892578125,
        1937.4725341796875,
        684.4706420898438
      ],
      "bbox_max": [
        1949.1397705078125,
        1956.2108154296875,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        1941.008056640625,
        1941.008056640625,
        695.0
      ],
      "bbox_max": [
        1949.1397705078125,
        1949.1397705078125,
        695.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        1933.93701171875,
        1948.0792236328125,
        694.0
      ],
      "bbox_max": [
        1942.0687255859375,
        1956.2108154296875,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2750.0,
      "bbox_min": [
        1933.93701171875,
        1948.0792236328125,
        694.0
      ],
      "bbox_max": [
        1941.008056640625,
        1955.1502685546875,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 694.0,
      "bbox_min": [
        1933.93701171875,
        1941.008056640625,
        694.0
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        695.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        1934.99755859375,
        1942.0687255859375,
        695.0
      ],
      "bbox_max": [
        1951.6146240234375,
        1958.685791015625,
        695.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071098685264587,
        -0.7071037888526917,
        0.0
      ],
      "plane_d": 9.9881591796875,
      "bbox_min": [
        1923.3304443359375,
        1923.3304443359375,
        720.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1955.1502685546875,
        740.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        1923.3304443359375,
        1923.3304443359375,
        720.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1955.1502685546875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070948481559753,
        0.7071187496185303,
        -0.0
      ],
      "plane_d": -2735.000244140625,
      "bbox_min": [
        1926.865966796875,
        1928.6337890625,
        720.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1955.1502685546875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8804726004600525,
        -0.47409701347351074,
        0.0
      ],
      "plane_d": -783.7496337890625,
      "bbox_min": [
        1928.6337890625,
        1928.6337890625,
        720.0
      ],
      "bbox_max": [
        1931.108642578125,
        1937.40185546875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9885658621788025,
        0.15078984200954437,
        -0.0
      ],
      "plane_d": -2200.53955078125,
      "bbox_min": [
        1930.4722900390625,
        1933.22998046875,
        720.0
      ],
      "bbox_max": [
        1931.108642578125,
        1937.40185546875,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 7.8997802734375,
      "bbox_min": [
        1926.865966796875,
        1938.120361328125,
        720.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1955.1502685546875,
        725.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -725.0,
      "bbox_min": [
        1926.865966796875,
        1939.5230712890625,
        725.0
      ],
      "bbox_max": [
        1942.4931640625,
        1955.1502685546875,
        725.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1728142946958542,
        -0.1728142946958542,
        0.9696754813194275
      ],
      "plane_d": -700.1143188476562,
      "bbox_min": [
        1928.3509521484375,
        1938.120361328125,
        723.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1953.665283203125,
        724.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 723.0,
      "bbox_min": [
        1928.3509521484375,
        1938.120361328125,
        723.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1953.665283203125,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 5.916015625,
      "bbox_min": [
        1929.7537841796875,
        1938.120361328125,
        723.0
      ],
      "bbox_max": [
        1943.8958740234375,
        1952.262451171875,
        723.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        1937.4725341796875,
        1842.01318359375,
        674.0
      ],
      "bbox_max": [
        2029.396484375,
        1933.93701171875,
        740.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 718.0,
      "bbox_min": [
        1937.4725341796875,
        1842.01318359375,
        698.0
      ],
      "bbox_max": [
        2029.396484375,
        1933.93701171875,
        740.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        1937.4725341796875,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2018.7899169921875,
        1933.93701171875,
        740.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        0.7071085572242737,
        0.0
      ],
      "plane_d": 64.9932861328125,
      "bbox_min": [
        1937.4725341796875,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2018.7899169921875,
        1933.93701171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1972.827880859375,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2018.7899169921875,
        1898.5816650390625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -69.9932861328125,
      "bbox_min": [
        1972.827880859375,
        1866.761962890625,
        718.0
      ],
      "bbox_max": [
        2004.647705078125,
        1898.5816650390625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 80.0,
      "bbox_min": [
        1979.8990478515625,
        1866.761962890625,
        718.0
      ],
      "bbox_max": [
        2004.647705078125,
        1891.5106201171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2722.0,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 107.2825927734375,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -112.282470703125,
      "bbox_min": [
        2002.8092041015625,
        1843.8516845703125,
        718.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1845.265869140625,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071085572242737,
        0.7071050405502319,
        0.0
      ],
      "plane_d": 35.0068359375,
      "bbox_min": [
        1937.4725341796875,
        1884.4395751953125,
        718.0
      ],
      "bbox_max": [
        1986.9700927734375,
        1933.93701171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 50.0,
      "bbox_min": [
        1951.61474609375,
        1884.4395751953125,
        718.0
      ],
      "bbox_max": [
        1986.9700927734375,
        1919.794921875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -55.0,
      "bbox_min": [
        1962.2213134765625,
        1884.4395751953125,
        718.0
      ],
      "bbox_max": [
        1986.9700927734375,
        1909.1883544921875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071085572242737,
        -0.7071050405502319,
        0.0
      ],
      "plane_d": -40.0068359375,
      "bbox_min": [
        1951.61474609375,
        1895.046142578125,
        718.0
      ],
      "bbox_max": [
        1976.3634033203125,
        1919.794921875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        0.7071085572242737,
        0.0
      ],
      "plane_d": 19.9931640625,
      "bbox_min": [
        1937.4725341796875,
        1905.65283203125,
        718.0
      ],
      "bbox_max": [
        1965.7568359375,
        1933.93701171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -24.9931640625,
      "bbox_min": [
        1941.008056640625,
        1905.65283203125,
        718.0
      ],
      "bbox_max": [
        1965.7568359375,
        1930.4014892578125,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2722.0,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        720.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 107.2825927734375,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        720.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -112.282470703125,
      "bbox_min": [
        2002.8092041015625,
        1843.8516845703125,
        720.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1845.265869140625,
        740.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1994.0411376953125,
        1842.01318359375,
        698.0
      ],
      "bbox_max": [
        2029.396484375,
        1877.3685302734375,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        1994.0411376953125,
        1842.01318359375,
        698.0
      ],
      "bbox_max": [
        2029.396484375,
        1877.3685302734375,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1994.0411376953125,
        1852.6197509765625,
        698.0
      ],
      "bbox_max": [
        2018.7899169921875,
        1877.3685302734375,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -710.0,
      "bbox_min": [
        1997.57666015625,
        1842.01318359375,
        700.0
      ],
      "bbox_max": [
        2011.71875,
        1856.1552734375,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1997.57666015625,
        1849.084228515625,
        700.0
      ],
      "bbox_max": [
        2011.71875,
        1856.1552734375,
        710.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2730.000244140625,
      "bbox_min": [
        2004.647705078125,
        1849.084228515625,
        700.0
      ],
      "bbox_max": [
        2011.71875,
        1856.1552734375,
        710.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2722.0,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        710.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 107.2825927734375,
      "bbox_min": [
        1999.273681640625,
        1843.8516845703125,
        710.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1848.8013916015625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -112.282470703125,
      "bbox_min": [
        2002.8092041015625,
        1843.8516845703125,
        710.0
      ],
      "bbox_max": [
        2004.2235107421875,
        1845.265869140625,
        718.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1870.8956298828125,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2039.7584228515625,
        1963.390869140625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1947.2630615234375,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2039.7584228515625,
        1963.390869140625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2750.0,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2039.7584228515625,
        1963.390869140625,
        665.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2745.000244140625,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -655.0,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 63.0,
      "bbox_min": [
        1953.736083984375,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1931.815673828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -78.0,
      "bbox_min": [
        1996.1624755859375,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1889.3892822265625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 93.0,
      "bbox_min": [
        2006.76904296875,
        1875.2471923828125,
        655.0
      ],
      "bbox_max": [
        2010.3045654296875,
        1878.78271484375,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 33.0,
      "bbox_min": [
        1953.736083984375,
        1907.0670166015625,
        655.0
      ],
      "bbox_max": [
        1978.4847412109375,
        1931.815673828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -48.0,
      "bbox_min": [
        1974.94921875,
        1907.0670166015625,
        655.0
      ],
      "bbox_max": [
        1978.4847412109375,
        1910.6025390625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -18.0001220703125,
      "bbox_min": [
        1953.736083984375,
        1928.2801513671875,
        655.0
      ],
      "bbox_max": [
        1957.2716064453125,
        1931.815673828125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071080803871155,
        0.7071055173873901,
        0.0
      ],
      "plane_d": 119.1590576171875,
      "bbox_min": [
        1947.2630615234375,
        1870.8956298828125,
        650.0
      ],
      "bbox_max": [
        2039.7584228515625,
        1963.390869140625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 11.1541748046875,
      "bbox_min": [
        1947.2630615234375,
        1880.7935791015625,
        650.0
      ],
      "bbox_max": [
        2029.859619140625,
        1963.390869140625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 69.0,
      "bbox_min": [
        1957.1611328125,
        1880.7935791015625,
        650.0
      ],
      "bbox_max": [
        2029.859619140625,
        1953.4921875,
        650.6016845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        2003.939697265625,
        1880.7935791015625,
        650.0
      ],
      "bbox_max": [
        2029.859619140625,
        1906.713623046875,
        650.6016845703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5439862012863159,
        -0.5426743030548096,
        0.6399871706962585
      ],
      "plane_d": 1708.689453125,
      "bbox_min": [
        2028.79833984375,
        1880.7935791015625,
        650.0
      ],
      "bbox_max": [
        2029.859619140625,
        1881.855712890625,
        650.6015014648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071053981781006,
        -0.7071081399917603,
        3.0375606002053246e-05
      ],
      "plane_d": -105.16940307617188,
      "bbox_min": [
        2029.5052490234375,
        1880.7935791015625,
        650.0
      ],
      "bbox_max": [
        2029.859619140625,
        1881.14794921875,
        650.6014404296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5425038933753967,
        -0.5439106225967407,
        0.6401959657669067
      ],
      "plane_d": 1707.906494140625,
      "bbox_min": [
        2003.939697265625,
        1905.65283203125,
        650.0
      ],
      "bbox_max": [
        2005.001220703125,
        1906.713623046875,
        650.6016845703125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -2.8779359126929194e-05
      ],
      "plane_d": -69.98129272460938,
      "bbox_min": [
        2004.647705078125,
        1905.65283203125,
        650.0
      ],
      "bbox_max": [
        2005.001220703125,
        1906.00634765625,
        650.6002807617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        -1.512640210421523e-06
      ],
      "plane_d": -3.849968910217285,
      "bbox_min": [
        1957.1611328125,
        1926.1588134765625,
        650.0
      ],
      "bbox_max": [
        1984.4951171875,
        1953.4921875,
        650.6015014648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5426743030548096,
        -0.5439862012863159,
        0.6399871706962585
      ],
      "plane_d": 1708.58935546875,
      "bbox_min": [
        1957.1611328125,
        1952.4307861328125,
        650.0
      ],
      "bbox_max": [
        1958.2232666015625,
        1953.4921875,
        650.6015014648438
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2.844970703125,
      "bbox_min": [
        1957.1611328125,
        1953.1376953125,
        650.0
      ],
      "bbox_max": [
        1957.515625,
        1953.4921875,
        650.6015014648438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5432621240615845,
        -0.543168306350708,
        0.64018315076828
      ],
      "plane_d": 1708.0181884765625,
      "bbox_min": [
        1983.4345703125,
        1926.1588134765625,
        650.0
      ],
      "bbox_max": [
        1984.4951171875,
        1927.219482421875,
        650.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        2.8770755307050422e-05
      ],
      "plane_d": 39.990943908691406,
      "bbox_min": [
        1983.4345703125,
        1926.1588134765625,
        650.0
      ],
      "bbox_max": [
        1984.4951171875,
        1927.219482421875,
        650.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -41.0001220703125,
      "bbox_min": [
        1984.1416015625,
        1926.1588134765625,
        650.0
      ],
      "bbox_max": [
        1984.4951171875,
        1926.5123291015625,
        650.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070997953414917,
        0.7071138024330139,
        0.0
      ],
      "plane_d": 144.1265869140625,
      "bbox_min": [
        1935.704833984375,
        1853.571533203125,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071102857589722,
        -0.7071033120155334,
        0.0
      ],
      "plane_d": -124.0137939453125,
      "bbox_min": [
        1935.704833984375,
        1853.571533203125,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        1135.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.07402343302965164,
        -0.0740232914686203,
        0.9945055246353149
      ],
      "plane_d": -376.3416748046875,
      "bbox_min": [
        1935.704833984375,
        1867.8223876953125,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071072459220886,
        -0.0
      ],
      "plane_d": 2895.0,
      "bbox_min": [
        1935.704833984375,
        1867.8223876953125,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071073651313782,
        0.0
      ],
      "plane_d": 2855.0,
      "bbox_min": [
        1935.704833984375,
        1867.8223876953125,
        370.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1998.9908447265625,
        1931.1087646484375,
        385.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        2010.902587890625,
        1934.5350341796875,
        385.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2010.902587890625,
        1934.5350341796875,
        385.0
      ],
      "bbox_max": [
        2117.186767578125,
        2040.819091796875,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2017.9737548828125,
        1940.899169921875,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        2023.032470703125,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 89.0,
      "bbox_min": [
        2028.689208984375,
        1952.32177734375,
        385.0
      ],
      "bbox_max": [
        2099.400146484375,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071050405502319,
        -0.7071085572242737,
        0.0
      ],
      "plane_d": -93.9930419921875,
      "bbox_min": [
        2085.258056640625,
        1952.32177734375,
        405.0
      ],
      "bbox_max": [
        2099.400146484375,
        1966.4638671875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0001220703125,
      "bbox_min": [
        2028.689208984375,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2068.5703125,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071050405502319,
        0.7071085572242737,
        0.0
      ],
      "plane_d": 13.992919921875,
      "bbox_min": [
        2028.689208984375,
        2008.8902587890625,
        405.0
      ],
      "bbox_max": [
        2042.83154296875,
        2023.032470703125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2047.0743408203125,
        1970.706787109375,
        385.0
      ],
      "bbox_max": [
        2068.5703125,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -388.5,
      "bbox_min": [
        2047.0743408203125,
        1970.706787109375,
        388.0
      ],
      "bbox_max": [
        2068.5703125,
        1992.9100341796875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.31622201204299927,
        0.3161128759384155,
        0.8944698572158813
      ],
      "plane_d": -1625.12890625,
      "bbox_min": [
        2048.771240234375,
        1991.49560546875,
        388.0
      ],
      "bbox_max": [
        2050.185546875,
        1992.9100341796875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2017.9737548828125,
        1940.899169921875,
        640.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        2017.9737548828125,
        1940.899169921875,
        640.0
      ],
      "bbox_max": [
        2097.0341796875,
        2019.95947265625,
        645.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        2025.044677734375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        2012.888427734375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2088.90234375,
        1948.677490234375,
        640.0
      ],
      "bbox_max": [
        2089.255859375,
        1949.031005859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1.0,
      "bbox_min": [
        2010.902587890625,
        1934.5350341796875,
        667.9998779296875
      ],
      "bbox_max": [
        2117.186767578125,
        2040.819091796875,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        2096.5712890625,
        1934.5350341796875,
        668.0
      ],
      "bbox_max": [
        2117.186767578125,
        1955.1502685546875,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 119.144287109375,
      "bbox_min": [
        2096.5712890625,
        1934.5350341796875,
        668.0
      ],
      "bbox_max": [
        2117.186767578125,
        1948.67724609375,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3638033866882324,
        0.3638033866882324,
        -0.8574930429458618
      ],
      "plane_d": -887.5048828125,
      "bbox_min": [
        2096.5712890625,
        1934.5350341796875,
        677.9998779296875
      ],
      "bbox_max": [
        2104.398681640625,
        1942.3621826171875,
        679.14892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        2010.902587890625,
        2019.4969482421875,
        668.0
      ],
      "bbox_max": [
        2025.0447998046875,
        2040.819091796875,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.36380335688591003,
        0.36380335688591003,
        -0.857492983341217
      ],
      "plane_d": -887.5048217773438,
      "bbox_min": [
        2010.902587890625,
        2019.4969482421875,
        677.9998779296875
      ],
      "bbox_max": [
        2019.436767578125,
        2028.031005859375,
        679.14892578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2875.000244140625,
      "bbox_min": [
        2017.9736328125,
        1941.6060791015625,
        680.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2017.9736328125,
        1941.6060791015625,
        680.0
      ],
      "bbox_max": [
        2117.186767578125,
        2040.819091796875,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071129083633423,
        0.7071006894111633,
        0.0
      ],
      "plane_d": 20.0247802734375,
      "bbox_min": [
        2032.9320068359375,
        2011.71875,
        680.0
      ],
      "bbox_max": [
        2047.0740966796875,
        2025.8609619140625,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        2032.9320068359375,
        2018.7899169921875,
        680.0
      ],
      "bbox_max": [
        2040.0030517578125,
        2025.8609619140625,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        2017.9736328125,
        2033.7479248046875,
        680.0
      ],
      "bbox_max": [
        2025.0447998046875,
        2040.819091796875,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.9998779296875,
      "bbox_min": [
        2068.287353515625,
        1941.6060791015625,
        680.0
      ],
      "bbox_max": [
        2117.186767578125,
        1990.505615234375,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        2103.642822265625,
        1948.0792236328125,
        680.0
      ],
      "bbox_max": [
        2110.713623046875,
        1955.1502685546875,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -89.9998779296875,
      "bbox_min": [
        2068.287353515625,
        1962.2213134765625,
        680.0
      ],
      "bbox_max": [
        2096.571533203125,
        1990.505615234375,
        681.0526733398438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071037888526917,
        -0.7071098685264587,
        0.0
      ],
      "plane_d": 11.16650390625,
      "bbox_min": [
        2025.0447998046875,
        2040.819091796875,
        680.0
      ],
      "bbox_max": [
        2039.18701171875,
        2054.961181640625,
        683.1578979492188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071062922477722,
        0.7071073651313782,
        -0.0
      ],
      "plane_d": -2815.0,
      "bbox_min": [
        1935.704833984375,
        1867.8223876953125,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        2038.5888671875,
        678.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1935.704833984375,
        1867.8223876953125,
        370.0
      ],
      "bbox_max": [
        2078.186767578125,
        2010.3045654296875,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 665.0,
      "bbox_min": [
        1947.6165771484375,
        1871.2491455078125,
        635.0
      ],
      "bbox_max": [
        2074.76025390625,
        1998.392578125,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071061730384827,
        -0.7071073651313782,
        -0.0
      ],
      "plane_d": 2813.0,
      "bbox_min": [
        1947.6165771484375,
        1871.2491455078125,
        635.0
      ],
      "bbox_max": [
        2074.76025390625,
        1998.392578125,
        665.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -86.3785400390625,
      "bbox_min": [
        1981.2042236328125,
        1904.8367919921875,
        635.0
      ],
      "bbox_max": [
        2074.76025390625,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -11.62158203125,
      "bbox_min": [
        1981.2042236328125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1981.2042236328125,
        1989.7984619140625,
        650.0
      ],
      "bbox_max": [
        1989.7984619140625,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1981.2042236328125,
        1989.7984619140625,
        650.0
      ],
      "bbox_max": [
        1989.7984619140625,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071118950843811,
        0.7071017026901245,
        0.0
      ],
      "plane_d": -0.979736328125,
      "bbox_min": [
        1981.2042236328125,
        1989.7984619140625,
        650.0
      ],
      "bbox_max": [
        1989.7984619140625,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071017026901245,
        -0.7071118950843811,
        0.0
      ],
      "plane_d": 11.1744384765625,
      "bbox_min": [
        1981.2042236328125,
        1996.978515625,
        650.0
      ],
      "bbox_max": [
        1982.6182861328125,
        1998.392578125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 21.5001220703125,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        635.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        1997.22314453125,
        1973.8885498046875,
        650.0
      ],
      "bbox_max": [
        2005.7083740234375,
        1982.3739013671875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 96.3785400390625,
      "bbox_min": [
        2050.256103515625,
        1904.8367919921875,
        635.0
      ],
      "bbox_max": [
        2074.76025390625,
        1929.3408203125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071017026901245,
        0.7071118950843811,
        0.0
      ],
      "plane_d": 119.1336669921875,
      "bbox_min": [
        2066.873046875,
        1904.8367919921875,
        650.0
      ],
      "bbox_max": [
        2074.76025390625,
        1912.723876953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071017026901245,
        -0.7071118950843811,
        0.0
      ],
      "plane_d": -109.979736328125,
      "bbox_min": [
        2066.873046875,
        1904.8367919921875,
        650.0
      ],
      "bbox_max": [
        2074.76025390625,
        1912.723876953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2066.873046875,
        1904.8367919921875,
        650.0
      ],
      "bbox_max": [
        2074.76025390625,
        1912.723876953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        2066.873046875,
        1904.8367919921875,
        660.0
      ],
      "bbox_max": [
        2074.76025390625,
        1912.723876953125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        1947.6165771484375,
        1871.2491455078125,
        635.0
      ],
      "bbox_max": [
        2074.651123046875,
        1996.978515625,
        665.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071080803871155,
        0.7071055173873901,
        0.0
      ],
      "plane_d": 119.1590576171875,
      "bbox_min": [
        1947.6165771484375,
        1871.2491455078125,
        635.0
      ],
      "bbox_max": [
        2074.651123046875,
        1996.978515625,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        2053.547119140625,
        1881.6112060546875,
        635.0
      ],
      "bbox_max": [
        2074.651123046875,
        1902.7154541015625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037292480469,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2809.99951171875,
      "bbox_min": [
        2053.547119140625,
        1881.6112060546875,
        635.0
      ],
      "bbox_max": [
        2074.651123046875,
        1902.7154541015625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2785.0,
      "bbox_min": [
        2053.547119140625,
        1881.6112060546875,
        635.0
      ],
      "bbox_max": [
        2056.9736328125,
        1885.0377197265625,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1947.6165771484375,
        1871.2491455078125,
        635.0
      ],
      "bbox_max": [
        2073.345947265625,
        1996.978515625,
        665.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.36380255222320557,
        0.36380425095558167,
        0.8574930429458618
      ],
      "plane_d": -1979.9510498046875,
      "bbox_min": [
        1958.2232666015625,
        1881.855712890625,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1986.3719482421875,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071094512939453,
        -0.7071041464805603,
        0.0
      ],
      "plane_d": -3.8563232421875,
      "bbox_min": [
        1958.2232666015625,
        1881.855712890625,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1986.3719482421875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2790.000244140625,
      "bbox_min": [
        1983.7880859375,
        1881.855712890625,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1944.543701171875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071043252944946,
        -0.7071092128753662,
        0.0
      ],
      "plane_d": -69.990478515625,
      "bbox_min": [
        1983.7880859375,
        1881.855712890625,
        635.0
      ],
      "bbox_max": [
        2046.47607421875,
        1944.543701171875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        -5.7925312546558416e-08
      ],
      "plane_d": 40.009681701660156,
      "bbox_min": [
        1983.7880859375,
        1927.219482421875,
        635.0
      ],
      "bbox_max": [
        2001.1121826171875,
        1944.543701171875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        2029.15185546875,
        1881.855712890625,
        635.0
      ],
      "bbox_max": [
        2046.47607421875,
        1899.179931640625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071027159690857,
        0.7071108222007751,
        -0.0
      ],
      "plane_d": -2794.999267578125,
      "bbox_min": [
        2004.647705078125,
        1892.1087646484375,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1944.543701171875,
        650.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        2004.647705078125,
        1899.1798095703125,
        635.0
      ],
      "bbox_max": [
        2050.011474609375,
        1944.543701171875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -65.0,
      "bbox_min": [
        2015.2542724609375,
        1926.865966796875,
        635.0
      ],
      "bbox_max": [
        2022.325439453125,
        1933.93701171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        2015.2542724609375,
        1926.865966796875,
        645.0
      ],
      "bbox_max": [
        2022.325439453125,
        1933.93701171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0001220703125,
      "bbox_min": [
        2004.647705078125,
        1930.4014892578125,
        635.0
      ],
      "bbox_max": [
        2017.3756103515625,
        1944.543701171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071189880371094,
        0.7070946097373962,
        0.0
      ],
      "plane_d": 45.048095703125,
      "bbox_min": [
        2004.647705078125,
        1937.4725341796875,
        635.0
      ],
      "bbox_max": [
        2011.71875,
        1944.543701171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        2004.647705078125,
        1937.4725341796875,
        645.0
      ],
      "bbox_max": [
        2011.71875,
        1944.543701171875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -639.5,
      "bbox_min": [
        2008.1832275390625,
        1930.4014892578125,
        639.0
      ],
      "bbox_max": [
        2017.3756103515625,
        1939.5938720703125,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 639.0,
      "bbox_min": [
        2008.1832275390625,
        1930.4014892578125,
        639.0
      ],
      "bbox_max": [
        2017.3756103515625,
        1939.5938720703125,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2793.000244140625,
      "bbox_min": [
        2010.3045654296875,
        1932.5228271484375,
        639.0
      ],
      "bbox_max": [
        2017.3756103515625,
        1939.5938720703125,
        639.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2805.000244140625,
      "bbox_min": [
        2050.011474609375,
        1892.1087646484375,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1915.443359375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707099199295044,
        0.7071144580841064,
        0.0
      ],
      "plane_d": 104.1236572265625,
      "bbox_min": [
        2057.08251953125,
        1909.7864990234375,
        635.0
      ],
      "bbox_max": [
        2062.739501953125,
        1915.443359375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        2050.011474609375,
        1892.1087646484375,
        648.0
      ],
      "bbox_max": [
        2067.689208984375,
        1909.7864990234375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071129083633423,
        0.7071006894111633,
        0.0
      ],
      "plane_d": 104.17822265625,
      "bbox_min": [
        2050.011474609375,
        1902.71533203125,
        648.0
      ],
      "bbox_max": [
        2057.08251953125,
        1909.7864990234375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 11.1541748046875,
      "bbox_min": [
        1947.6165771484375,
        1881.14794921875,
        650.0
      ],
      "bbox_max": [
        2063.447265625,
        1996.978515625,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 104.154052734375,
      "bbox_min": [
        1957.5155029296875,
        1881.14794921875,
        650.0
      ],
      "bbox_max": [
        2063.447265625,
        1987.0797119140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071053981781006,
        -0.7071081399917603,
        3.0375606002053246e-05
      ],
      "plane_d": -105.16940307617188,
      "bbox_min": [
        2029.15185546875,
        1881.14794921875,
        650.0
      ],
      "bbox_max": [
        2063.447265625,
        1915.443359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -653.0,
      "bbox_min": [
        2029.15185546875,
        1881.14794921875,
        650.600341796875
      ],
      "bbox_max": [
        2063.447265625,
        1915.443359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5431683659553528,
        -0.5432620644569397,
        0.64018315076828
      ],
      "plane_d": 1708.0078125,
      "bbox_min": [
        2029.15185546875,
        1881.14794921875,
        650.600341796875
      ],
      "bbox_max": [
        2031.27294921875,
        1883.26904296875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071080803871155,
        -0.7071055173873901,
        -1.512640210421523e-06
      ],
      "plane_d": -3.849968910217285,
      "bbox_min": [
        1957.5155029296875,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2022.325439453125,
        1987.0797119140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2.844970703125,
      "bbox_min": [
        1957.5155029296875,
        1952.7843017578125,
        650.0
      ],
      "bbox_max": [
        1991.810791015625,
        1987.0797119140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -653.0,
      "bbox_min": [
        1957.515625,
        1952.7843017578125,
        650.6002807617188
      ],
      "bbox_max": [
        1991.810791015625,
        1987.0797119140625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5432229042053223,
        -0.5432229042053223,
        0.640170156955719
      ],
      "plane_d": 1708.053466796875,
      "bbox_min": [
        1957.515625,
        1952.7843017578125,
        650.6002807617188
      ],
      "bbox_max": [
        1959.6365966796875,
        1954.9053955078125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067094802856,
        0.7071067094802856,
        0.00043158369953744113
      ],
      "plane_d": -2790.2802734375,
      "bbox_min": [
        1983.7880859375,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2022.325439453125,
        1944.543701171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -652.9999389648438,
      "bbox_min": [
        1983.7880859375,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2022.325439453125,
        1944.543701171875,
        653.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2788.9990234375,
      "bbox_min": [
        1983.7880859375,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2022.325439453125,
        1944.543701171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -2.8779359126929194e-05
      ],
      "plane_d": -69.98129272460938,
      "bbox_min": [
        2000.4041748046875,
        1922.6224365234375,
        650.0
      ],
      "bbox_max": [
        2022.325439453125,
        1944.543701171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        2.8770755307050422e-05
      ],
      "plane_d": 39.990943908691406,
      "bbox_min": [
        2000.4041748046875,
        1943.8355712890625,
        650.0
      ],
      "bbox_max": [
        2001.1121826171875,
        1944.543701171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 69.0,
      "bbox_min": [
        1983.7880859375,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2021.617431640625,
        1943.835693359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        -2.8779359126929194e-05
      ],
      "plane_d": -69.98129272460938,
      "bbox_min": [
        2004.2943115234375,
        1906.00634765625,
        650.0
      ],
      "bbox_max": [
        2021.617431640625,
        1922.6224365234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5433228015899658,
        -0.5433228015899658,
        0.6400005221366882
      ],
      "plane_d": 1708.554931640625,
      "bbox_min": [
        2004.2943115234375,
        1906.00634765625,
        650.6002807617188
      ],
      "bbox_max": [
        2006.4146728515625,
        1908.1268310546875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -41.0001220703125,
      "bbox_min": [
        1983.7880859375,
        1926.5123291015625,
        650.0
      ],
      "bbox_max": [
        2001.111328125,
        1943.835693359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        0.7071043252944946,
        2.8770755307050422e-05
      ],
      "plane_d": 39.990943908691406,
      "bbox_min": [
        1983.7880859375,
        1926.5123291015625,
        650.0
      ],
      "bbox_max": [
        2000.4041748046875,
        1943.835693359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5432621240615845,
        -0.543168306350708,
        0.64018315076828
      ],
      "plane_d": 1708.0181884765625,
      "bbox_min": [
        1983.7880859375,
        1926.5123291015625,
        650.5999755859375
      ],
      "bbox_max": [
        1985.909423828125,
        1928.6337890625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1970.70654296875,
        1902.824462890625,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        2038.5888671875,
        678.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.36380335688591003,
        0.36380335688591003,
        -0.857492983341217
      ],
      "plane_d": -887.5048217773438,
      "bbox_min": [
        1989.6895751953125,
        1913.322021484375,
        660.0
      ],
      "bbox_max": [
        2103.044677734375,
        2026.677001953125,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        1989.6895751953125,
        1913.322021484375,
        660.0
      ],
      "bbox_max": [
        2103.044677734375,
        2026.677001953125,
        678.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        1989.6895751953125,
        1998.2838134765625,
        660.0
      ],
      "bbox_max": [
        2018.0826416015625,
        2026.677001953125,
        677.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1.0,
      "bbox_min": [
        1996.8695068359375,
        1998.2838134765625,
        660.0
      ],
      "bbox_max": [
        2018.0826416015625,
        2026.677001953125,
        677.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2001.474609375,
        2010.06884765625,
        660.0
      ],
      "bbox_max": [
        2018.08251953125,
        2026.677001953125,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 119.144287109375,
      "bbox_min": [
        2081.831298828125,
        1913.322021484375,
        660.0
      ],
      "bbox_max": [
        2103.044677734375,
        1941.0081787109375,
        677.9998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2087.1435546875,
        1925.1070556640625,
        660.0
      ],
      "bbox_max": [
        2103.044677734375,
        1941.0081787109375,
        668.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        1970.70654296875,
        1902.824462890625,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        2038.5888671875,
        660.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1981.3131103515625,
        1913.4310302734375,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        2038.5888671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -19.0,
      "bbox_min": [
        1981.3131103515625,
        1913.4310302734375,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        2038.5888671875,
        660.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 14.0,
      "bbox_min": [
        1981.3131103515625,
        1991.212646484375,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        2038.5888671875,
        660.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2835.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        370.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        410.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.8902587890625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        530.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2032.224853515625,
        2008.890380859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000008344650269,
        0.5000008344650269,
        -0.7071056962013245
      ],
      "plane_d": -1552.103515625,
      "bbox_min": [
        2014.5472412109375,
        1991.212646484375,
        640.0
      ],
      "bbox_max": [
        2021.6182861328125,
        1998.2838134765625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1981.3131103515625,
        1994.857177734375,
        370.0
      ],
      "bbox_max": [
        2025.044677734375,
        2038.5888671875,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        1981.3131103515625,
        2001.92822265625,
        385.0
      ],
      "bbox_max": [
        2017.9737548828125,
        2038.5888671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        1993.22509765625,
        2001.92822265625,
        653.0
      ],
      "bbox_max": [
        2008.5455322265625,
        2017.2489013671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        1993.22509765625,
        2008.999267578125,
        653.0
      ],
      "bbox_max": [
        2001.474609375,
        2017.2489013671875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        2007.3671875,
        1994.857177734375,
        640.0
      ],
      "bbox_max": [
        2025.044677734375,
        2012.53466796875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2000.296142578125,
        2001.8193359375,
        653.0
      ],
      "bbox_max": [
        2008.654541015625,
        2010.1778564453125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1.0,
      "bbox_min": [
        2000.405029296875,
        2001.8193359375,
        653.0
      ],
      "bbox_max": [
        2008.654541015625,
        2010.06884765625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070946097373962,
        0.7071189880371094,
        0.0
      ],
      "plane_d": 88.951171875,
      "bbox_min": [
        2021.6182861328125,
        1913.4310302734375,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        1998.2838134765625,
        660.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.7071189880371094,
        -0.7070945501327515,
        0.0
      ],
      "plane_d": -94.0489501953125,
      "bbox_min": [
        2067.580322265625,
        1913.4310302734375,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        1955.8572998046875,
        660.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        0.7071189880371094,
        0.7070945501327515,
        0.0
      ],
      "plane_d": -2835.00146484375,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        370.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        660.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -410.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        410.0
      ],
      "bbox_max": [
        2085.258056640625,
        1955.8572998046875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        530.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2085.2578125,
        1955.8572998046875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4999879002571106,
        0.5000051259994507,
        -0.7071117162704468
      ],
      "plane_d": -1552.0810546875,
      "bbox_min": [
        2067.580322265625,
        1938.1796875,
        640.0
      ],
      "bbox_max": [
        2074.6513671875,
        1945.250732421875,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.141845703125,
      "bbox_min": [
        2071.224609375,
        1913.4310302734375,
        370.0
      ],
      "bbox_max": [
        2106.470947265625,
        1948.677490234375,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        2079.0029296875,
        1913.4310302734375,
        385.0
      ],
      "bbox_max": [
        2106.470947265625,
        1940.899169921875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 119.144287109375,
      "bbox_min": [
        2085.366943359375,
        1916.8575439453125,
        653.0
      ],
      "bbox_max": [
        2093.616455078125,
        1925.1070556640625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2071.224609375,
        1930.999755859375,
        640.0
      ],
      "bbox_max": [
        2088.90234375,
        1948.677490234375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2078.89404296875,
        1923.2215576171875,
        653.0
      ],
      "bbox_max": [
        2087.25244140625,
        1931.580078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        2078.89404296875,
        1923.3304443359375,
        653.0
      ],
      "bbox_max": [
        2087.1435546875,
        1931.580078125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -470.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        370.84906005859375
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583312988281
      ],
      "plane_d": 1071.3109130859375,
      "bbox_min": [
        2029.396484375,
        1953.0289306640625,
        370.84906005859375
      ],
      "bbox_max": [
        2066.873291015625,
        1990.5057373046875,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 48.0,
      "bbox_min": [
        2029.396484375,
        1953.0289306640625,
        370.84906005859375
      ],
      "bbox_max": [
        2066.873291015625,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2035.0533447265625,
        1953.0289306640625,
        370.84906005859375
      ],
      "bbox_max": [
        2066.873291015625,
        1984.848876953125,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483167886734009,
        -0.3483167886734009,
        0.8702590465545654
      ],
      "plane_d": 1068.26123046875,
      "bbox_min": [
        2035.0533447265625,
        1953.0289306640625,
        374.34906005859375
      ],
      "bbox_max": [
        2066.873291015625,
        1984.848876953125,
        388.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 40.0,
      "bbox_min": [
        2029.396484375,
        1972.120849609375,
        370.84906005859375
      ],
      "bbox_max": [
        2047.7813720703125,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583909034729
      ],
      "plane_d": 1068.264892578125,
      "bbox_min": [
        2029.396484375,
        1972.120849609375,
        374.34906005859375
      ],
      "bbox_max": [
        2047.7813720703125,
        1990.5057373046875,
        388.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        515.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        515.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        590.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        515.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2056.9736328125,
        1945.250732421875,
        515.625
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2021.6182861328125,
        1969.99951171875,
        515.625
      ],
      "bbox_max": [
        2049.902587890625,
        1998.2838134765625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2032.224853515625,
        1969.99951171875,
        515.625
      ],
      "bbox_max": [
        2049.902587890625,
        1987.6771240234375,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2032.224853515625,
        1955.8572998046875,
        575.625
      ],
      "bbox_max": [
        2064.044677734375,
        1987.6771240234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2032.224853515625,
        1969.99951171875,
        575.625
      ],
      "bbox_max": [
        2049.902587890625,
        1987.6771240234375,
        590.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -398.52392578125,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        635.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        635.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        2021.6182861328125,
        1945.250732421875,
        635.625
      ],
      "bbox_max": [
        2074.6513671875,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2056.9736328125,
        1945.250732421875,
        635.625
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2021.6182861328125,
        1969.99951171875,
        635.625
      ],
      "bbox_max": [
        2049.902587890625,
        1998.2838134765625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707105278968811,
        -0.7071083784103394,
        0.0
      ],
      "plane_d": -43.9937744140625,
      "bbox_min": [
        2032.224853515625,
        1969.99951171875,
        635.625
      ],
      "bbox_max": [
        2049.902587890625,
        1987.6771240234375,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        1970.70654296875,
        1902.824462890625,
        370.0
      ],
      "bbox_max": [
        2088.79345703125,
        2020.9111328125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        0.7071098685264587,
        0.0
      ],
      "plane_d": 110.141845703125,
      "bbox_min": [
        1970.70654296875,
        1902.824462890625,
        370.0
      ],
      "bbox_max": [
        2088.79345703125,
        2020.9111328125,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        2068.396240234375,
        1902.824462890625,
        385.0
      ],
      "bbox_max": [
        2088.79345703125,
        1923.2215576171875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071017026901245,
        0.7071118950843811,
        0.0
      ],
      "plane_d": 119.1336669921875,
      "bbox_min": [
        2068.396240234375,
        1906.2509765625,
        650.0
      ],
      "bbox_max": [
        2085.366943359375,
        1923.2215576171875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2068.396240234375,
        1906.2509765625,
        650.0
      ],
      "bbox_max": [
        2085.366943359375,
        1923.2215576171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2075.46728515625,
        1913.322021484375,
        650.0
      ],
      "bbox_max": [
        2085.366943359375,
        1923.2215576171875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1.1541748046875,
      "bbox_min": [
        1970.70654296875,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2079.0029296875,
        2020.9111328125,
        660.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        1970.70654296875,
        1991.3216552734375,
        385.0
      ],
      "bbox_max": [
        2000.296142578125,
        2020.9111328125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071017026901245,
        -0.7071118950843811,
        0.0
      ],
      "plane_d": 11.1744384765625,
      "bbox_min": [
        1982.6182861328125,
        1991.32177734375,
        650.0
      ],
      "bbox_max": [
        2000.296142578125,
        2008.999267578125,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1982.6182861328125,
        1991.32177734375,
        650.0
      ],
      "bbox_max": [
        2000.296142578125,
        2008.999267578125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071027159690857,
        0.7071108222007751,
        0.0
      ],
      "plane_d": 83.98388671875,
      "bbox_min": [
        1989.689453125,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        2049.902587890625,
        1912.614990234375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1941.7152099609375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2060.6181640625,
        1919.6859130859375,
        370.0
      ],
      "bbox_max": [
        2075.46728515625,
        1927.464111328125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        370.0
      ],
      "bbox_max": [
        2067.689208984375,
        1927.464111328125,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        2052.73095703125,
        1912.614990234375,
        382.0
      ],
      "bbox_max": [
        2075.46728515625,
        1938.88671875,
        385.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071123719215393,
        0.7071012854576111,
        0.0
      ],
      "plane_d": -2825.0009765625,
      "bbox_min": [
        2052.73095703125,
        1919.6859130859375,
        382.0
      ],
      "bbox_max": [
        2075.46728515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 99.154052734375,
      "bbox_min": [
        2052.73095703125,
        1920.39306640625,
        382.0
      ],
      "bbox_max": [
        2067.689208984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 94.87841796875,
      "bbox_min": [
        2052.73095703125,
        1924.74462890625,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.004150390625,
      "bbox_min": [
        2060.50927734375,
        1924.74462890625,
        382.0
      ],
      "bbox_max": [
        2061.92333984375,
        1926.1588134765625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8782958984375,
      "bbox_min": [
        2052.73095703125,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        -0.0
      ],
      "plane_d": -2819.00390625,
      "bbox_min": [
        2054.145263671875,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2055.559326171875,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071372866630554,
        0.7070762515068054,
        0.0
      ],
      "plane_d": 95.1220703125,
      "bbox_min": [
        2059.094970703125,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        0.7071372866630554,
        -0.0
      ],
      "plane_d": -2827.995849609375,
      "bbox_min": [
        2066.873046875,
        1931.108642578125,
        382.0
      ],
      "bbox_max": [
        2068.287353515625,
        1932.5228271484375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        -0.0
      ],
      "plane_d": 2825.99609375,
      "bbox_min": [
        2059.094970703125,
        1936.058349609375,
        382.0
      ],
      "bbox_max": [
        2060.50927734375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 85.8780517578125,
      "bbox_min": [
        2059.094970703125,
        1937.4725341796875,
        382.0
      ],
      "bbox_max": [
        2060.50927734375,
        1938.88671875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -382.0,
      "bbox_min": [
        1989.689453125,
        1951.96826171875,
        370.0
      ],
      "bbox_max": [
        2049.1953125,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1951.96826171875,
        370.0
      ],
      "bbox_max": [
        2049.1953125,
        1998.3927001953125,
        382.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        370.0
      ],
      "bbox_max": [
        2003.8316650390625,
        1991.3216552734375,
        382.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34831249713897705,
        -0.3483211100101471,
        0.8702591061592102
      ],
      "plane_d": 1071.306884765625,
      "bbox_min": [
        2026.5679931640625,
        1951.96826171875,
        370.0
      ],
      "bbox_max": [
        2049.1953125,
        1972.827880859375,
        374.34906005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070823311805725,
        0.7071312069892883,
        0.0
      ],
      "plane_d": 47.90234375,
      "bbox_min": [
        2026.5679931640625,
        1951.96826171875,
        370.0
      ],
      "bbox_max": [
        2049.1953125,
        1972.827880859375,
        374.34906005859375
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067094802856,
        -0.7071067094802856,
        0.0
      ],
      "plane_d": -68.0,
      "bbox_min": [
        2031.517822265625,
        1951.96826171875,
        370.0
      ],
      "bbox_max": [
        2049.1953125,
        1967.1710205078125,
        374.34906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2031.517822265625,
        1951.96826171875,
        373.0
      ],
      "bbox_max": [
        2049.1953125,
        1967.1710205078125,
        374.34906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31623297929763794,
        -0.31623297929763794,
        0.8944236040115356
      ],
      "plane_d": 929.7791748046875,
      "bbox_min": [
        2031.517822265625,
        1962.928466796875,
        373.0
      ],
      "bbox_max": [
        2032.9320068359375,
        1964.3426513671875,
        373.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.34834685921669006,
        -0.3482867181301117,
        0.8702590465545654
      ],
      "plane_d": 1068.26416015625,
      "bbox_min": [
        2033.99267578125,
        1951.96826171875,
        373.5
      ],
      "bbox_max": [
        2049.1953125,
        1967.1710205078125,
        374.34906005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070823311805725,
        0.7071312069892883,
        0.0
      ],
      "plane_d": 39.90234375,
      "bbox_min": [
        2026.5679931640625,
        1969.2923583984375,
        370.0
      ],
      "bbox_max": [
        2030.1036376953125,
        1972.827880859375,
        374.34906005859375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -373.5,
      "bbox_min": [
        2026.5679931640625,
        1969.2923583984375,
        373.5
      ],
      "bbox_max": [
        2030.1036376953125,
        1972.827880859375,
        374.34906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3483176529407501,
        -0.3483176529407501,
        0.8702583909034729
      ],
      "plane_d": 1068.264892578125,
      "bbox_min": [
        2028.3358154296875,
        1971.0601806640625,
        373.5
      ],
      "bbox_max": [
        2030.1036376953125,
        1972.827880859375,
        374.34906005859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -385.0,
      "bbox_min": [
        1989.689453125,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2825.000244140625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1998.3927001953125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.3216552734375,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 19.87841796875,
      "bbox_min": [
        1999.697998046875,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071372866630554,
        -0.7070762515068054,
        0.0
      ],
      "plane_d": -22.1217041015625,
      "bbox_min": [
        2007.4761962890625,
        1976.3634033203125,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1977.7777099609375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1979.19189453125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 11.0,
      "bbox_min": [
        1999.697998046875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2819.000244140625,
      "bbox_min": [
        2001.1121826171875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        2001.1121826171875,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2002.5263671875,
        1984.1416015625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -13.0,
      "bbox_min": [
        2006.0618896484375,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 10.8779296875,
      "bbox_min": [
        2006.0618896484375,
        1989.0914306640625,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": 2825.99951171875,
      "bbox_min": [
        2006.0618896484375,
        1989.0914306640625,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.000244140625,
      "bbox_min": [
        2007.4761962890625,
        1990.505615234375,
        382.0
      ],
      "bbox_max": [
        2008.890380859375,
        1991.9197998046875,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2826.000244140625,
      "bbox_min": [
        2012.4259033203125,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2828.0,
      "bbox_min": [
        2013.840087890625,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1985.5557861328125,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -22.0,
      "bbox_min": [
        2013.840087890625,
        1982.7274169921875,
        382.0
      ],
      "bbox_max": [
        2015.2542724609375,
        1984.1416015625,
        385.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -590.0,
      "bbox_min": [
        1989.6893310546875,
        1912.614990234375,
        510.0
      ],
      "bbox_max": [
        2079.0029296875,
        2001.92822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707105278968811,
        0.7071083188056946,
        0.0
      ],
      "plane_d": 43.993896484375,
      "bbox_min": [
        2011.01171875,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.9736328125,
        1980.6060791015625,
        590.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -64.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.9736328125,
        1955.8572998046875,
        590.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        510.0
      ],
      "bbox_max": [
        2056.9736328125,
        1955.8572998046875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        530.0
      ],
      "bbox_max": [
        2056.9736328125,
        1955.8572998046875,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071083188056946,
        0.707105278968811,
        0.0
      ],
      "plane_d": 29.006103515625,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        510.0
      ],
      "bbox_max": [
        2032.224853515625,
        1980.6060791015625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -530.0,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        530.0
      ],
      "bbox_max": [
        2032.224853515625,
        1980.6060791015625,
        530.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 64.0,
      "bbox_min": [
        1989.6893310546875,
        1912.614990234375,
        630.0
      ],
      "bbox_max": [
        2079.0029296875,
        2001.92822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2035.7603759765625,
        1912.614990234375,
        630.0
      ],
      "bbox_max": [
        2079.0029296875,
        1955.8572998046875,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2482801079750061,
        0.24828295409679413,
        -0.9363293051719666
      ],
      "plane_d": -398.52392578125,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        630.0
      ],
      "bbox_max": [
        2056.9736328125,
        1955.8572998046875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2035.7603759765625,
        1934.6441650390625,
        650.0
      ],
      "bbox_max": [
        2056.9736328125,
        1955.8572998046875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        2060.6181640625,
        1912.614990234375,
        640.0
      ],
      "bbox_max": [
        2079.0029296875,
        1930.999755859375,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        2060.6181640625,
        1912.614990234375,
        640.0
      ],
      "bbox_max": [
        2079.0029296875,
        1930.999755859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707109808921814,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 99.1661376953125,
      "bbox_min": [
        2060.6181640625,
        1920.39306640625,
        640.0
      ],
      "bbox_max": [
        2071.224609375,
        1930.999755859375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071017026901245,
        -0.7071118950843811,
        0.0
      ],
      "plane_d": -109.979736328125,
      "bbox_min": [
        2068.287353515625,
        1912.614990234375,
        650.0
      ],
      "bbox_max": [
        2079.0029296875,
        1923.3304443359375,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        2075.3583984375,
        1919.68603515625,
        650.0
      ],
      "bbox_max": [
        2079.0029296875,
        1923.3304443359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24828200042247772,
        0.24828200042247772,
        -0.9363290667533875
      ],
      "plane_d": -398.526123046875,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        630.0
      ],
      "bbox_max": [
        2032.224853515625,
        1980.6060791015625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        2011.01171875,
        1959.3929443359375,
        650.0
      ],
      "bbox_max": [
        2032.224853515625,
        1980.6060791015625,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -645.0,
      "bbox_min": [
        1989.6893310546875,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2007.3671875,
        2001.92822265625,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 640.0,
      "bbox_min": [
        1989.689453125,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2007.3671875,
        2001.92822265625,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -8.845947265625,
      "bbox_min": [
        1996.7606201171875,
        1984.2506103515625,
        640.0
      ],
      "bbox_max": [
        2007.3671875,
        1994.857177734375,
        645.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071118950843811,
        0.7071017026901245,
        0.0
      ],
      "plane_d": -0.979736328125,
      "bbox_min": [
        1989.6893310546875,
        1991.212646484375,
        650.0
      ],
      "bbox_max": [
        2000.405029296875,
        2001.92822265625,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        1989.6893310546875,
        1991.212646484375,
        650.0
      ],
      "bbox_max": [
        2000.405029296875,
        2001.92822265625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3638038635253906,
        -0.3638038635253906,
        0.8574926257133484
      ],
      "plane_d": 896.0819702148438,
      "bbox_min": [
        1996.760498046875,
        1998.2838134765625,
        650.0
      ],
      "bbox_max": [
        2000.405029296875,
        2001.92822265625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1944.897216796875,
        1874.1865234375,
        670.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        737.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.49930500984191895,
        0.49930500984191895,
        -0.7080883383750916
      ],
      "plane_d": -1456.760986328125,
      "bbox_min": [
        1951.96826171875,
        1874.1865234375,
        700.0
      ],
      "bbox_max": [
        2121.3203125,
        2032.9320068359375,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2785.000244140625,
      "bbox_min": [
        1951.96826171875,
        1874.1865234375,
        700.5123291015625
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 90.0,
      "bbox_min": [
        1951.96826171875,
        1874.1865234375,
        700.5123291015625
      ],
      "bbox_max": [
        2040.0030517578125,
        1962.2213134765625,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.22192995250225067,
        -0.22192995250225067,
        -0.9494705200195312
      ],
      "plane_d": 1538.7587890625,
      "bbox_min": [
        2029.75,
        1874.1865234375,
        700.5123291015625
      ],
      "bbox_max": [
        2040.0030517578125,
        1884.4395751953125,
        706.4874877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        2029.75,
        1874.1865234375,
        700.5123291015625
      ],
      "bbox_max": [
        2040.0030517578125,
        1884.4395751953125,
        706.4874877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        2029.75,
        1881.257568359375,
        700.5123291015625
      ],
      "bbox_max": [
        2032.9320068359375,
        1884.4395751953125,
        706.4874877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        1951.96826171875,
        1891.8642578125,
        700.5123901367188
      ],
      "bbox_max": [
        2032.9320068359375,
        1962.2213134765625,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 705.0,
      "bbox_min": [
        1951.96826171875,
        1951.96826171875,
        700.5123901367188
      ],
      "bbox_max": [
        1962.2213134765625,
        1962.2213134765625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1951.96826171875,
        1951.96826171875,
        700.5123901367188
      ],
      "bbox_max": [
        1962.2213134765625,
        1962.2213134765625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1959.039306640625,
        1951.96826171875,
        700.5123901367188
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.1502685546875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 732.0,
      "bbox_min": [
        2005.001220703125,
        1891.8642578125,
        720.0
      ],
      "bbox_max": [
        2032.9320068359375,
        1912.723876953125,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": 2774.99951171875,
      "bbox_min": [
        2005.001220703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2025.8609619140625,
        1912.723876953125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        2018.7899169921875,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2025.8609619140625,
        1912.723876953125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -70.0,
      "bbox_min": [
        2005.001220703125,
        1906.00634765625,
        720.0
      ],
      "bbox_max": [
        2011.71875,
        1912.723876953125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622856855392456,
        0.31622856855392456,
        -0.8944265842437744
      ],
      "plane_d": -590.7727661132812,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 737.0,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071079015731812,
        0.7071056962013245,
        0.0
      ],
      "plane_d": 90.0042724609375,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -20.0,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        720.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622856855392456,
        -0.31622856855392456,
        -0.8944265842437744
      ],
      "plane_d": 645.7759399414062,
      "bbox_min": [
        1983.4345703125,
        1905.65283203125,
        732.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1963.6885986328125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162286579608917,
        0.31622767448425293,
        -0.8944268822669983
      ],
      "plane_d": 694.9716186523438,
      "bbox_min": [
        2032.9320068359375,
        1905.65283203125,
        732.0
      ],
      "bbox_max": [
        2041.4703369140625,
        1924.8074951171875,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        1951.96826171875,
        1874.1865234375,
        700.0
      ],
      "bbox_max": [
        2121.3203125,
        2032.9320068359375,
        737.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1959.039306640625,
        1951.96826171875,
        700.0
      ],
      "bbox_max": [
        1962.2213134765625,
        1955.1502685546875,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 115.0,
      "bbox_min": [
        1965.786376953125,
        1877.3685302734375,
        700.0
      ],
      "bbox_max": [
        2121.3203125,
        2032.9320068359375,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 737.0,
      "bbox_min": [
        1965.786376953125,
        1888.004638671875,
        700.0
      ],
      "bbox_max": [
        2121.3203125,
        2032.9320068359375,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071079015731812,
        0.7071056962013245,
        0.0
      ],
      "plane_d": 90.0042724609375,
      "bbox_min": [
        1983.4639892578125,
        1905.6822509765625,
        720.0
      ],
      "bbox_max": [
        2121.3203125,
        2002.8800048828125,
        737.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 99.989990234375,
      "bbox_min": [
        2082.429443359375,
        1948.0792236328125,
        720.0
      ],
      "bbox_max": [
        2121.3203125,
        1986.9700927734375,
        732.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 732.0,
      "bbox_min": [
        2082.429443359375,
        1948.0792236328125,
        720.0
      ],
      "bbox_max": [
        2121.3203125,
        1986.9700927734375,
        732.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2855.000244140625,
      "bbox_min": [
        2082.429443359375,
        1948.0792236328125,
        720.0
      ],
      "bbox_max": [
        2121.3203125,
        1986.9700927734375,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2900.000244140625,
      "bbox_min": [
        2114.249267578125,
        1979.8990478515625,
        720.0
      ],
      "bbox_max": [
        2121.3203125,
        1986.9700927734375,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -20.0,
      "bbox_min": [
        1983.4639892578125,
        1914.191162109375,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31622955203056335,
        -0.316228449344635,
        -0.8944262862205505
      ],
      "plane_d": 1924.8115234375,
      "bbox_min": [
        1991.972900390625,
        1914.191162109375,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071087956428528,
        -0.7071047425270081,
        0.0
      ],
      "plane_d": 2865.0,
      "bbox_min": [
        2043.53857421875,
        1955.1502685546875,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        732.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.33275577425956726,
        -0.33275577425956726,
        -0.8823531866073608
      ],
      "plane_d": 603.5296630859375,
      "bbox_min": [
        2091.268310546875,
        1979.8990478515625,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071051597595215,
        0.7071083784103394,
        -0.0
      ],
      "plane_d": -2889.999755859375,
      "bbox_min": [
        2091.268310546875,
        1979.8990478515625,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071051597595215,
        -0.7071083784103394,
        -0.0
      ],
      "plane_d": 2899.999755859375,
      "bbox_min": [
        2098.33935546875,
        1986.9700927734375,
        720.0
      ],
      "bbox_max": [
        2114.249267578125,
        2002.8800048828125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 732.0,
      "bbox_min": [
        2043.53857421875,
        1955.1502685546875,
        720.0
      ],
      "bbox_max": [
        2089.50048828125,
        1990.505615234375,
        732.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2855.000244140625,
      "bbox_min": [
        2043.53857421875,
        1955.1502685546875,
        720.0
      ],
      "bbox_max": [
        2082.429443359375,
        1990.505615234375,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2043.53857421875,
        1965.7568359375,
        724.4998779296875
      ],
      "bbox_max": [
        2061.21630859375,
        1983.4345703125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071027159690857,
        0.7071108222007751,
        0.0
      ],
      "plane_d": 59.9837646484375,
      "bbox_min": [
        2050.609619140625,
        1965.7568359375,
        724.4998779296875
      ],
      "bbox_max": [
        2061.21630859375,
        1976.3634033203125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2054.145263671875,
        1983.4345703125,
        720.0
      ],
      "bbox_max": [
        2061.21630859375,
        1990.505615234375,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.31622856855392456,
        -0.31622856855392456,
        -0.8944265842437744
      ],
      "plane_d": 645.7759399414062,
      "bbox_min": [
        1991.972900390625,
        1914.191162109375,
        720.0
      ],
      "bbox_max": [
        2082.429443359375,
        1994.0411376953125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3162286579608917,
        0.31622767448425293,
        -0.8944268822669983
      ],
      "plane_d": 694.9716186523438,
      "bbox_min": [
        2007.2166748046875,
        1914.191162109375,
        720.0
      ],
      "bbox_max": [
        2082.429443359375,
        1994.0411376953125,
        737.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071087956428528,
        -0.7071047425270081,
        0.0
      ],
      "plane_d": 2840.0,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2082.429443359375,
        1994.0411376953125,
        732.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2855.000244140625,
      "bbox_min": [
        2043.53857421875,
        1955.1502685546875,
        720.0
      ],
      "bbox_max": [
        2082.429443359375,
        1989.7982177734375,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2043.53857421875,
        1965.7568359375,
        720.0
      ],
      "bbox_max": [
        2061.21630859375,
        1983.4345703125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071027159690857,
        0.7071108222007751,
        0.0
      ],
      "plane_d": 59.9837646484375,
      "bbox_min": [
        2050.609619140625,
        1965.7568359375,
        720.0
      ],
      "bbox_max": [
        2061.21630859375,
        1976.3634033203125,
        732.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2054.145263671875,
        1983.4345703125,
        720.0
      ],
      "bbox_max": [
        2060.509033203125,
        1989.7982177734375,
        724.4998779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38269272446632385,
        -0.9238757491111755,
        0.0
      ],
      "plane_d": 1006.5993041992188,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.92387855052948,
        0.3826860785484314,
        0.0
      ],
      "plane_d": 1108.2452392578125,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238774180412292,
        -0.38268885016441345,
        0.0
      ],
      "plane_d": -1145.953857421875,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268885016441345,
        0.9238774180412292,
        0.0
      ],
      "plane_d": -1044.326904296875,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9238722920417786,
        0.38270100951194763,
        0.0
      ],
      "plane_d": -2638.336669921875,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.38270100951194763,
        0.9238722920417786,
        0.0
      ],
      "plane_d": -2596.243408203125,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38270100951194763,
        -0.9238722920417786,
        -0.0
      ],
      "plane_d": 2558.52685546875,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238750338554382,
        -0.3826943039894104,
        -0.0
      ],
      "plane_d": 2600.612548828125,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -723.0,
      "bbox_min": [
        2007.2166748046875,
        1929.434814453125,
        720.0
      ],
      "bbox_max": [
        2048.040771484375,
        1970.259033203125,
        723.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.3826923370361328,
        -0.9238758087158203,
        0.0
      ],
      "plane_d": 1039.316650390625,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1964.8470458984375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238796234130859,
        0.38268330693244934,
        0.0
      ],
      "plane_d": 1140.96923828125,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1964.8470458984375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38268330693244934,
        0.9238796234130859,
        0.0
      ],
      "plane_d": -1011.6260375976562,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1964.8470458984375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.38269615173339844,
        -0.9238743185997009,
        0.0
      ],
      "plane_d": 2591.237548828125,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1964.8470458984375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        -0.3826870322227478,
        0.0
      ],
      "plane_d": -1113.2423095703125,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1960.4534912109375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.923878014087677,
        0.3826870322227478,
        -0.0
      ],
      "plane_d": -2605.6044921875,
      "bbox_min": [
        2012.628662109375,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1960.4534912109375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3826870322227478,
        0.923878014087677,
        -0.0
      ],
      "plane_d": -2563.509765625,
      "bbox_min": [
        2017.0220947265625,
        1934.846923828125,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1960.4534912109375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9238765835762024,
        -0.3826908469200134,
        0.0
      ],
      "plane_d": 2633.32568359375,
      "bbox_min": [
        2038.2353515625,
        1949.8470458984375,
        720.0
      ],
      "bbox_max": [
        2042.6287841796875,
        1960.4534912109375,
        723.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -9.9998779296875,
      "bbox_min": [
        2004.647705078125,
        1926.865966796875,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2032.9320068359375,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2840.0,
      "bbox_min": [
        2004.647705078125,
        2001.1121826171875,
        700.0
      ],
      "bbox_max": [
        2015.2542724609375,
        2011.71875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707111656665802,
        0.7071019411087036,
        0.0
      ],
      "plane_d": 100.0196533203125,
      "bbox_min": [
        2024.7119140625,
        1926.865966796875,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2032.9320068359375,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        -0.7071027159690857,
        -0.0
      ],
      "plane_d": 2840.00048828125,
      "bbox_min": [
        2078.89404296875,
        1926.865966796875,
        700.0
      ],
      "bbox_max": [
        2089.50048828125,
        1937.4725341796875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071049213409424,
        -0.7071086764335632,
        0.0
      ],
      "plane_d": 2885.0,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2032.9320068359375,
        720.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.33275577425956726,
        0.33275577425956726,
        0.8823531866073608
      ],
      "plane_d": -592.94140625,
      "bbox_min": [
        2070.05517578125,
        1979.8990478515625,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2020.5576171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071051597595215,
        0.7071083784103394,
        -0.0
      ],
      "plane_d": -2889.999755859375,
      "bbox_min": [
        2070.05517578125,
        1979.8990478515625,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2020.5576171875,
        720.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071189880371094,
        0.7070945501327515,
        0.0
      ],
      "plane_d": 52.5498046875,
      "bbox_min": [
        2070.05517578125,
        2002.8800048828125,
        700.0
      ],
      "bbox_max": [
        2080.66162109375,
        2013.486572265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 712.0,
      "bbox_min": [
        2070.05517578125,
        2002.8800048828125,
        712.0
      ],
      "bbox_max": [
        2080.66162109375,
        2013.486572265625,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071051597595215,
        -0.7071083784103394,
        -0.0
      ],
      "plane_d": 2899.999755859375,
      "bbox_min": [
        2073.590576171875,
        1986.9700927734375,
        700.0
      ],
      "bbox_max": [
        2114.249267578125,
        2020.5576171875,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 712.0,
      "bbox_min": [
        2073.590576171875,
        2006.41552734375,
        706.6666870117188
      ],
      "bbox_max": [
        2087.732666015625,
        2020.5576171875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -42.4998779296875,
      "bbox_min": [
        2073.590576171875,
        2013.486572265625,
        706.6666870117188
      ],
      "bbox_max": [
        2080.66162109375,
        2020.5576171875,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -42.4998779296875,
      "bbox_min": [
        2073.590576171875,
        2013.486572265625,
        700.0
      ],
      "bbox_max": [
        2080.66162109375,
        2020.5576171875,
        706.666748046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        -0.7071043252944946,
        -0.0
      ],
      "plane_d": 2862.5,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        2016.6685791015625,
        720.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071018815040588,
        0.7071115970611572,
        0.0
      ],
      "plane_d": 42.4803466796875,
      "bbox_min": [
        2042.1243896484375,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        2016.6685791015625,
        720.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.7071019411087036,
        -0.707111656665802,
        0.0
      ],
      "plane_d": -67.480224609375,
      "bbox_min": [
        2055.205810546875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1995.101806640625,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2864.000244140625,
      "bbox_min": [
        2055.205810546875,
        1978.83837890625,
        700.0
      ],
      "bbox_max": [
        2087.732666015625,
        1995.101806640625,
        720.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -703.0,
      "bbox_min": [
        2057.6806640625,
        1979.8990478515625,
        703.0
      ],
      "bbox_max": [
        2069.347900390625,
        1991.5662841796875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 708.0,
      "bbox_min": [
        2057.6806640625,
        1979.8990478515625,
        703.0
      ],
      "bbox_max": [
        2069.347900390625,
        1991.5662841796875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070661187171936,
        -0.707147479057312,
        0.0
      ],
      "plane_d": -47.3353271484375,
      "bbox_min": [
        2057.6806640625,
        1979.8990478515625,
        703.0
      ],
      "bbox_max": [
        2069.347900390625,
        1991.5662841796875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707147479057312,
        0.7070661187171936,
        0.0
      ],
      "plane_d": 62.66455078125,
      "bbox_min": [
        2068.287353515625,
        1979.8990478515625,
        703.0
      ],
      "bbox_max": [
        2069.347900390625,
        1980.959716796875,
        708.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070956826210022,
        0.7071179151535034,
        0.0
      ],
      "plane_d": 65.454833984375,
      "bbox_min": [
        2071.46923828125,
        1978.83837890625,
        700.0
      ],
      "bbox_max": [
        2087.732666015625,
        1993.6876220703125,
        720.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071372866630554,
        0.7070762515068054,
        0.0
      ],
      "plane_d": -2875.002685546875,
      "bbox_min": [
        2079.24755859375,
        1985.2022705078125,
        700.0
      ],
      "bbox_max": [
        2087.732666015625,
        1993.6876220703125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 712.0,
      "bbox_min": [
        2079.24755859375,
        1985.2022705078125,
        712.0
      ],
      "bbox_max": [
        2087.732666015625,
        1993.6876220703125,
        712.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2872.00048828125,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1977.7777099609375,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2868.0,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1977.7777099609375,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -705.0,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1977.7777099609375,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7016398310661316,
        -0.7016478776931763,
        0.12406386435031891
      ],
      "plane_d": 2761.85009765625,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1977.7777099609375,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 75.495849609375,
      "bbox_min": [
        2083.048095703125,
        1966.3756103515625,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1977.7777099609375,
        705.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -90.48035430908203,
      "bbox_min": [
        2093.65478515625,
        1966.3756103515625,
        700.0
      ],
      "bbox_max": [
        2094.4501953125,
        1967.171142578125,
        705.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.0,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2093.7431640625,
        1977.070556640625,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        2081.01513671875,
        1964.3426513671875,
        700.0
      ],
      "bbox_max": [
        2093.7431640625,
        1977.070556640625,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070735692977905,
        0.7071400880813599,
        -2.746157770161517e-05
      ],
      "plane_d": 74.88418579101562,
      "bbox_min": [
        2081.01513671875,
        1974.9493408203125,
        700.0
      ],
      "bbox_max": [
        2083.136474609375,
        1977.070556640625,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2872.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2868.000244140625,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -705.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7016475796699524,
        -0.7016475796699524,
        0.12402168661355972
      ],
      "plane_d": 2761.895263671875,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        705.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -35.48047637939453,
      "bbox_min": [
        2044.1572265625,
        2005.2664794921875,
        700.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        705.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 20.4957275390625,
      "bbox_min": [
        2044.1572265625,
        2015.873046875,
        700.0
      ],
      "bbox_max": [
        2044.9527587890625,
        2016.6685791015625,
        705.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2054.852294921875,
        2015.96142578125,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -35.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        700.0
      ],
      "bbox_max": [
        2054.852294921875,
        2015.96142578125,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071262001991272,
        0.7070873379707336,
        4.119061486562714e-05
      ],
      "plane_d": 20.050065994262695,
      "bbox_min": [
        2042.1243896484375,
        2013.840087890625,
        700.0
      ],
      "bbox_max": [
        2044.2457275390625,
        2015.96142578125,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7016416788101196,
        -0.7016497254371643,
        0.12404277920722961
      ],
      "plane_d": 2748.228759765625,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        703.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2858.000244140625,
      "bbox_min": [
        2034.4345703125,
        1956.65283203125,
        700.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        703.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -703.0,
      "bbox_min": [
        2034.4345703125,
        1956.65283203125,
        700.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        703.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7069846987724304,
        -0.7072288393974304,
        0.0
      ],
      "plane_d": -62.0067138671875,
      "bbox_min": [
        2034.4345703125,
        1956.65283203125,
        700.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        703.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -4.315925980336033e-05
      ],
      "plane_d": -35.46299743652344,
      "bbox_min": [
        2034.4345703125,
        1986.704833984375,
        700.0
      ],
      "bbox_max": [
        2054.498779296875,
        2006.76904296875,
        703.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        0.7072288393974304,
        0.0
      ],
      "plane_d": 19.506591796875,
      "bbox_min": [
        2034.4345703125,
        2006.1502685546875,
        700.0
      ],
      "bbox_max": [
        2035.0533447265625,
        2006.76904296875,
        703.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.5,
      "bbox_min": [
        2053.880126953125,
        1986.704833984375,
        700.0
      ],
      "bbox_max": [
        2054.498779296875,
        1987.3236083984375,
        703.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -90.47820281982422,
      "bbox_min": [
        2073.325439453125,
        1956.65283203125,
        700.0
      ],
      "bbox_max": [
        2084.55078125,
        1967.878173828125,
        703.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 74.9998779296875,
      "bbox_min": [
        2073.325439453125,
        1967.2593994140625,
        700.0
      ],
      "bbox_max": [
        2073.944091796875,
        1967.878173828125,
        703.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7016516327857971,
        -0.7016435861587524,
        0.12402170896530151
      ],
      "plane_d": 2734.608154296875,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        701.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071027159690857,
        0.7071108222007751,
        -0.0
      ],
      "plane_d": -2843.99951171875,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        701.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -701.0,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        701.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -62.515159606933594,
      "bbox_min": [
        2024.7119140625,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -35.015159606933594,
      "bbox_min": [
        2024.7119140625,
        1976.982177734375,
        700.0
      ],
      "bbox_max": [
        2044.5992431640625,
        1996.8695068359375,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2024.7119140625,
        1996.4276123046875,
        700.0
      ],
      "bbox_max": [
        2025.15380859375,
        1996.8695068359375,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.5,
      "bbox_min": [
        2044.1573486328125,
        1976.982177734375,
        700.0
      ],
      "bbox_max": [
        2044.5992431640625,
        1977.424072265625,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -8.631476521259174e-05
      ],
      "plane_d": -90.4304428100586,
      "bbox_min": [
        2063.602783203125,
        1946.9300537109375,
        700.0
      ],
      "bbox_max": [
        2074.6513671875,
        1957.9786376953125,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        2063.602783203125,
        1957.5367431640625,
        700.0
      ],
      "bbox_max": [
        2064.044677734375,
        1957.9786376953125,
        701.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071072459220886,
        -0.0
      ],
      "plane_d": 2895.0,
      "bbox_min": [
        1944.897216796875,
        1874.1865234375,
        670.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6101239919662476,
        0.6101239919662476,
        -0.5054674744606018
      ],
      "plane_d": -2129.38134765625,
      "bbox_min": [
        1944.897216796875,
        1874.1865234375,
        670.0
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -10.0,
      "bbox_min": [
        1944.897216796875,
        1874.1865234375,
        670.0
      ],
      "bbox_max": [
        2113.9931640625,
        2037.6253662109375,
        700.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.36380335688591003,
        0.36380335688591003,
        -0.857492983341217
      ],
      "plane_d": -887.5048217773438,
      "bbox_min": [
        1944.897216796875,
        1959.039306640625,
        670.0
      ],
      "bbox_max": [
        2026.2027587890625,
        2037.6253662109375,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2770.000244140625,
      "bbox_min": [
        1944.897216796875,
        1959.039306640625,
        670.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1969.2923583984375,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": 15.0238037109375,
      "bbox_min": [
        1944.897216796875,
        1959.039306640625,
        670.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1969.2923583984375,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1944.897216796875,
        1959.039306640625,
        680.0
      ],
      "bbox_max": [
        1955.1502685546875,
        1969.2923583984375,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        2012.2567138671875,
        2028.031005859375,
        679.14892578125
      ],
      "bbox_max": [
        2021.85107421875,
        2037.6253662109375,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        1951.96826171875,
        1948.4327392578125,
        670.0
      ],
      "bbox_max": [
        2029.0311279296875,
        2033.2738037109375,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2770.000244140625,
      "bbox_min": [
        1951.96826171875,
        1948.4327392578125,
        670.0
      ],
      "bbox_max": [
        1965.7568359375,
        1962.2213134765625,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1951.96826171875,
        1948.4327392578125,
        670.0
      ],
      "bbox_max": [
        1965.7568359375,
        1962.2213134765625,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 680.0,
      "bbox_min": [
        1951.96826171875,
        1948.4327392578125,
        680.0
      ],
      "bbox_max": [
        1965.7568359375,
        1962.2213134765625,
        680.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": -1.0,
      "bbox_min": [
        2019.436767578125,
        2020.85107421875,
        679.14892578125
      ],
      "bbox_max": [
        2029.0311279296875,
        2030.4454345703125,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -698.0,
      "bbox_min": [
        1965.0498046875,
        1951.61474609375,
        695.0
      ],
      "bbox_max": [
        2015.2542724609375,
        2001.8193359375,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        1965.0498046875,
        1951.61474609375,
        695.0
      ],
      "bbox_max": [
        1965.7568359375,
        1952.32177734375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2840.0,
      "bbox_min": [
        2014.547119140625,
        2001.1121826171875,
        695.0
      ],
      "bbox_max": [
        2015.2542724609375,
        2001.8193359375,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        1965.0498046875,
        1951.61474609375,
        698.0
      ],
      "bbox_max": [
        1965.7568359375,
        1952.32177734375,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 5.0,
      "bbox_min": [
        1959.039306640625,
        1951.96826171875,
        695.0
      ],
      "bbox_max": [
        1965.0498046875,
        1955.1502685546875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        1962.2213134765625,
        1952.32177734375,
        695.0
      ],
      "bbox_max": [
        1965.0498046875,
        1955.1502685546875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071074843406677,
        0.7071061730384827,
        0.0
      ],
      "plane_d": 100.002685546875,
      "bbox_min": [
        1962.5748291015625,
        1874.1865234375,
        670.0
      ],
      "bbox_max": [
        2113.9931640625,
        2025.8609619140625,
        700.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.3638033866882324,
        0.3638033866882324,
        -0.8574930429458618
      ],
      "plane_d": -887.5048828125,
      "bbox_min": [
        2101.461181640625,
        1935.88916015625,
        679.14892578125
      ],
      "bbox_max": [
        2113.9931640625,
        1948.4208984375,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 119.144287109375,
      "bbox_min": [
        2104.398681640625,
        1935.88916015625,
        679.14892578125
      ],
      "bbox_max": [
        2113.9931640625,
        1945.4835205078125,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -695.0,
      "bbox_min": [
        2029.396484375,
        1874.1865234375,
        679.1488647460938
      ],
      "bbox_max": [
        2111.055419921875,
        1951.95654296875,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        2097.925537109375,
        1942.362060546875,
        679.1488647460938
      ],
      "bbox_max": [
        2107.52001953125,
        1951.95654296875,
        687.2900390625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -698.0,
      "bbox_min": [
        2029.396484375,
        1887.2679443359375,
        695.0
      ],
      "bbox_max": [
        2079.60107421875,
        1937.4725341796875,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        2029.396484375,
        1887.2679443359375,
        695.0
      ],
      "bbox_max": [
        2030.1036376953125,
        1887.97509765625,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        -0.7071027159690857,
        -0.0
      ],
      "plane_d": 2840.00048828125,
      "bbox_min": [
        2078.89404296875,
        1936.7655029296875,
        695.0
      ],
      "bbox_max": [
        2079.60107421875,
        1937.4725341796875,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        -0.7071027159690857,
        -0.0
      ],
      "plane_d": 2840.00048828125,
      "bbox_min": [
        2078.89404296875,
        1936.7655029296875,
        698.0
      ],
      "bbox_max": [
        2079.60107421875,
        1937.4725341796875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071108222007751,
        -0.7071027159690857,
        -0.0
      ],
      "plane_d": 2840.00048828125,
      "bbox_min": [
        2029.75,
        1874.1865234375,
        695.0
      ],
      "bbox_max": [
        2089.50048828125,
        1936.7655029296875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -105.0,
      "bbox_min": [
        2029.75,
        1881.257568359375,
        695.0
      ],
      "bbox_max": [
        2032.9320068359375,
        1884.4395751953125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 695.0,
      "bbox_min": [
        1962.5748291015625,
        1884.7930908203125,
        670.0
      ],
      "bbox_max": [
        2103.642578125,
        2025.8609619140625,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2770.000244140625,
      "bbox_min": [
        1965.7568359375,
        1887.97509765625,
        695.0
      ],
      "bbox_max": [
        2103.642578125,
        2025.8609619140625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2831.000244140625,
      "bbox_min": [
        2008.1832275390625,
        1930.401611328125,
        695.0
      ],
      "bbox_max": [
        2103.642578125,
        2025.8609619140625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2830.0,
      "bbox_min": [
        2008.1832275390625,
        1930.401611328125,
        695.0
      ],
      "bbox_max": [
        2072.530029296875,
        1994.7481689453125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -697.9999389648438,
      "bbox_min": [
        2008.1832275390625,
        1930.401611328125,
        698.0
      ],
      "bbox_max": [
        2072.530029296875,
        1994.7481689453125,
        698.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10000059753656387,
        -0.10000059753656387,
        0.9899494647979736
      ],
      "plane_d": -286.3758544921875,
      "bbox_min": [
        2015.2542724609375,
        1937.4725341796875,
        695.0
      ],
      "bbox_max": [
        2103.642578125,
        2025.8609619140625,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071092128753662,
        -0.7071043252944946,
        0.0
      ],
      "plane_d": 2862.500244140625,
      "bbox_min": [
        2022.325439453125,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2094.4501953125,
        2016.6685791015625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071018815040588,
        0.7071115970611572,
        0.0
      ],
      "plane_d": 42.4803466796875,
      "bbox_min": [
        2042.1243896484375,
        1964.3426513671875,
        698.2142944335938
      ],
      "bbox_max": [
        2094.4501953125,
        2016.6685791015625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071108222007751,
        0.7071027159690857,
        -0.0
      ],
      "plane_d": -2872.00048828125,
      "bbox_min": [
        2075.7119140625,
        1964.3426513671875,
        699.0
      ],
      "bbox_max": [
        2094.4501953125,
        1985.2022705078125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070735692977905,
        0.7071400880813599,
        -2.746157770161517e-05
      ],
      "plane_d": 74.88418579101562,
      "bbox_min": [
        2075.7119140625,
        1964.3426513671875,
        699.0
      ],
      "bbox_max": [
        2094.4501953125,
        1983.0811767578125,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        2091.621826171875,
        1964.3426513671875,
        699.0
      ],
      "bbox_max": [
        2094.4501953125,
        1967.171142578125,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071019411087036,
        -0.707111656665802,
        0.0
      ],
      "plane_d": -67.480224609375,
      "bbox_min": [
        2075.7119140625,
        1980.2525634765625,
        699.0
      ],
      "bbox_max": [
        2078.54052734375,
        1983.0811767578125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071019411087036,
        -0.707111656665802,
        0.0
      ],
      "plane_d": -67.480224609375,
      "bbox_min": [
        2078.54052734375,
        1983.0811767578125,
        699.5714721679688
      ],
      "bbox_max": [
        2080.66162109375,
        1985.2022705078125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071019411087036,
        -0.707111656665802,
        0.0
      ],
      "plane_d": -67.480224609375,
      "bbox_min": [
        2071.82275390625,
        1976.363525390625,
        698.2142944335938
      ],
      "bbox_max": [
        2075.7119140625,
        1980.2525634765625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2872.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        699.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -35.0,
      "bbox_min": [
        2042.1243896484375,
        2003.2335205078125,
        699.0
      ],
      "bbox_max": [
        2055.559326171875,
        2016.6685791015625,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071262001991272,
        0.7070873379707336,
        4.119061486562714e-05
      ],
      "plane_d": 20.050065994262695,
      "bbox_min": [
        2042.1243896484375,
        2013.840087890625,
        699.0
      ],
      "bbox_max": [
        2044.9527587890625,
        2016.6685791015625,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071027159690857,
        0.7071108222007751,
        -0.0
      ],
      "plane_d": -2843.99951171875,
      "bbox_min": [
        2022.325439453125,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2840.000244140625,
      "bbox_min": [
        2022.325439453125,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.5,
      "bbox_min": [
        2022.325439453125,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2074.6513671875,
        1996.8695068359375,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016516327857971,
        -0.7016435861587524,
        0.12402170896530151
      ],
      "plane_d": 2734.608154296875,
      "bbox_min": [
        2041.7708740234375,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2074.6513671875,
        1976.982177734375,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        2054.357421875,
        1946.5235595703125,
        695.3999633789062
      ],
      "bbox_max": [
        2074.6513671875,
        1966.8175048828125,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -8.631476521259174e-05
      ],
      "plane_d": -90.4304428100586,
      "bbox_min": [
        2073.802734375,
        1946.5235595703125,
        695.3999633789062
      ],
      "bbox_max": [
        2074.6513671875,
        1947.3720703125,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -62.515159606933594,
      "bbox_min": [
        2054.357421875,
        1965.9691162109375,
        695.4000244140625
      ],
      "bbox_max": [
        2055.205810546875,
        1966.8175048828125,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -697.0,
      "bbox_min": [
        2041.7708740234375,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2073.944091796875,
        1976.717041015625,
        697.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 75.0,
      "bbox_min": [
        2052.37744140625,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2073.944091796875,
        1966.1103515625,
        697.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -89.9998779296875,
      "bbox_min": [
        2071.82275390625,
        1944.543701171875,
        695.0
      ],
      "bbox_max": [
        2073.944091796875,
        1946.6650390625,
        697.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707086443901062,
        -0.7071271538734436,
        0.0
      ],
      "plane_d": -62.418212890625,
      "bbox_min": [
        2052.37744140625,
        1963.9891357421875,
        695.0
      ],
      "bbox_max": [
        2054.498779296875,
        1966.1103515625,
        697.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -35.015159606933594,
      "bbox_min": [
        2024.30517578125,
        1985.414306640625,
        695.3999633789062
      ],
      "bbox_max": [
        2035.7603759765625,
        1996.8695068359375,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2024.30517578125,
        1996.0208740234375,
        695.3999633789062
      ],
      "bbox_max": [
        2025.15380859375,
        1996.8695068359375,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.707086443901062,
        -0.7071271538734436,
        0.0
      ],
      "plane_d": -34.918212890625,
      "bbox_min": [
        2022.325439453125,
        1983.4345703125,
        695.0
      ],
      "bbox_max": [
        2035.0533447265625,
        1996.1624755859375,
        697.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071012854576111,
        0.7071123719215393,
        -5.49207252333872e-05
      ],
      "plane_d": 20.015953063964844,
      "bbox_min": [
        2022.325439453125,
        1994.0411376953125,
        695.0
      ],
      "bbox_max": [
        2024.4466552734375,
        1996.1624755859375,
        697.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2858.000244140625,
      "bbox_min": [
        2032.224853515625,
        1954.443115234375,
        697.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2854.000244140625,
      "bbox_min": [
        2032.224853515625,
        1954.443115234375,
        697.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -62.4998779296875,
      "bbox_min": [
        2032.224853515625,
        1954.443115234375,
        697.0
      ],
      "bbox_max": [
        2084.55078125,
        2006.76904296875,
        700.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -699.0,
      "bbox_min": [
        2032.224853515625,
        1973.8885498046875,
        697.0
      ],
      "bbox_max": [
        2064.486572265625,
        2006.76904296875,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071271538734436,
        -0.707086443901062,
        0.0
      ],
      "plane_d": -35.0821533203125,
      "bbox_min": [
        2032.224853515625,
        1984.4951171875,
        697.0
      ],
      "bbox_max": [
        2054.498779296875,
        2006.76904296875,
        699.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070929408073425,
        0.7071206569671631,
        1.3730486898566596e-05
      ],
      "plane_d": 19.934398651123047,
      "bbox_min": [
        2032.224853515625,
        2003.940673828125,
        697.0
      ],
      "bbox_max": [
        2035.0533447265625,
        2006.76904296875,
        699.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071262001991272,
        0.7070873379707336,
        4.119061486562714e-05
      ],
      "plane_d": 47.549781799316406,
      "bbox_min": [
        2051.67041015625,
        1984.4951171875,
        697.0
      ],
      "bbox_max": [
        2054.498779296875,
        1987.3236083984375,
        699.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016457319259644,
        -0.7016457319259644,
        0.12404277920722961
      ],
      "plane_d": 2748.229248046875,
      "bbox_min": [
        2034.34619140625,
        1976.0098876953125,
        699.0
      ],
      "bbox_max": [
        2064.486572265625,
        2006.76904296875,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -4.315925980336033e-05
      ],
      "plane_d": -35.46299743652344,
      "bbox_min": [
        2034.34619140625,
        1986.616455078125,
        699.0
      ],
      "bbox_max": [
        2054.498779296875,
        2006.76904296875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        0.7072288393974304,
        0.0
      ],
      "plane_d": 19.506591796875,
      "bbox_min": [
        2034.34619140625,
        2006.0618896484375,
        699.0
      ],
      "bbox_max": [
        2035.0533447265625,
        2006.76904296875,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 47.5,
      "bbox_min": [
        2053.791748046875,
        1986.616455078125,
        699.0
      ],
      "bbox_max": [
        2054.498779296875,
        1987.3236083984375,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        2071.11572265625,
        1954.443115234375,
        697.0
      ],
      "bbox_max": [
        2084.55078125,
        1967.878173828125,
        699.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071123719215393,
        0.7071012854576111,
        5.49207252333872e-05
      ],
      "plane_d": 74.98406219482422,
      "bbox_min": [
        2071.11572265625,
        1965.0498046875,
        697.0
      ],
      "bbox_max": [
        2073.944091796875,
        1967.878173828125,
        699.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -90.47820281982422,
      "bbox_min": [
        2073.237060546875,
        1956.564453125,
        699.0
      ],
      "bbox_max": [
        2084.55078125,
        1967.878173828125,
        700.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1962.5748291015625,
        1884.7930908203125,
        670.0
      ],
      "bbox_max": [
        2101.5712890625,
        2023.789794921875,
        695.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2865.000244140625,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2101.5712890625,
        2023.789794921875,
        695.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        2032.9320068359375,
        1955.1502685546875,
        680.0
      ],
      "bbox_max": [
        2101.5712890625,
        2023.789794921875,
        690.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2040.0030517578125,
        1962.2213134765625,
        680.0
      ],
      "bbox_max": [
        2094.500244140625,
        2016.71875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071129083633423,
        0.7071006894111633,
        0.0
      ],
      "plane_d": 20.0247802734375,
      "bbox_min": [
        2040.0030517578125,
        2011.71875,
        680.0
      ],
      "bbox_max": [
        2045.0029296875,
        2016.71875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -89.9998779296875,
      "bbox_min": [
        2068.287353515625,
        1962.2213134765625,
        680.0
      ],
      "bbox_max": [
        2094.500244140625,
        1988.4344482421875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 60.0,
      "bbox_min": [
        2068.287353515625,
        1983.4345703125,
        680.0
      ],
      "bbox_max": [
        2073.287109375,
        1988.4344482421875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2808.000244140625,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071047425270081,
        0.7071087956428528,
        -0.0
      ],
      "plane_d": -2794.0,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2049.195556640625,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071087956428528,
        0.7071047425270081,
        -0.0
      ],
      "plane_d": -2780.0,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2039.2958984375,
        1961.51416015625,
        678.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071047425270081,
        -0.7071087956428528,
        0.0
      ],
      "plane_d": 2776.0,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2029.396484375,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -676.5,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2029.396484375,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071035504341125,
        0.7071035504341125,
        -0.0030413740314543247
      ],
      "plane_d": -2777.929931640625,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2029.396484375,
        1951.61474609375,
        676.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7016457319259644,
        -0.7016457319259644,
        0.12404277920722961
      ],
      "plane_d": 2674.118896484375,
      "bbox_min": [
        1977.070556640625,
        1899.288818359375,
        670.631591796875
      ],
      "bbox_max": [
        2029.396484375,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071685791015625,
        0.7070450186729431,
        2.6583222734188894e-07
      ],
      "plane_d": 60.242740631103516,
      "bbox_min": [
        1979.0528564453125,
        1901.271240234375,
        670.9266967773438
      ],
      "bbox_max": [
        2029.396484375,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -2.1575875507551245e-05
      ],
      "plane_d": -89.98548889160156,
      "bbox_min": [
        2028.550537109375,
        1901.271240234375,
        670.9266967773438
      ],
      "bbox_max": [
        2029.396484375,
        1902.1171875,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -2.1575875507551245e-05
      ],
      "plane_d": -49.98536682128906,
      "bbox_min": [
        2000.2659912109375,
        1929.5552978515625,
        670.9266967773438
      ],
      "bbox_max": [
        2001.1121826171875,
        1930.4014892578125,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071271538734436,
        -0.707086443901062,
        0.0
      ],
      "plane_d": -50.0799560546875,
      "bbox_min": [
        1998.2838134765625,
        1927.5731201171875,
        670.631591796875
      ],
      "bbox_max": [
        2000.405029296875,
        1929.6944580078125,
        672.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -2.1575875507551245e-05
      ],
      "plane_d": -49.98536682128906,
      "bbox_min": [
        1979.887451171875,
        1930.389892578125,
        671.0509033203125
      ],
      "bbox_max": [
        2001.1121826171875,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        1979.887451171875,
        1951.6031494140625,
        671.0509033203125
      ],
      "bbox_max": [
        1979.8990478515625,
        1951.61474609375,
        676.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -678.0,
      "bbox_min": [
        1986.9700927734375,
        1909.1883544921875,
        672.1052856445312
      ],
      "bbox_max": [
        2039.2958984375,
        1961.51416015625,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016457319259644,
        -0.7016457319259644,
        0.12404277920722961
      ],
      "plane_d": 2687.82470703125,
      "bbox_min": [
        1986.9700927734375,
        1909.1883544921875,
        672.1052856445312
      ],
      "bbox_max": [
        2039.2958984375,
        1961.51416015625,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7069846987724304,
        -0.7072288393974304,
        4.315925980336033e-05
      ],
      "plane_d": -49.546913146972656,
      "bbox_min": [
        1988.9500732421875,
        1911.1683349609375,
        672.4000244140625
      ],
      "bbox_max": [
        2039.2958984375,
        1961.51416015625,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0001220703125,
      "bbox_min": [
        1988.9500732421875,
        1960.665771484375,
        672.4000244140625
      ],
      "bbox_max": [
        1989.7984619140625,
        1961.51416015625,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 60.4822998046875,
      "bbox_min": [
        2017.234375,
        1911.1683349609375,
        672.4000244140625
      ],
      "bbox_max": [
        2039.2958984375,
        1933.22998046875,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -90.01466369628906,
      "bbox_min": [
        2038.447509765625,
        1911.1683349609375,
        672.4000244140625
      ],
      "bbox_max": [
        2039.2958984375,
        1912.0167236328125,
        678.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067094802856,
        0.7071067094802856,
        0.0
      ],
      "plane_d": 60.0,
      "bbox_min": [
        1986.9700927734375,
        1909.1883544921875,
        672.1052856445312
      ],
      "bbox_max": [
        2038.5888671875,
        1960.80712890625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        1986.9700927734375,
        1958.685791015625,
        672.1052856445312
      ],
      "bbox_max": [
        1989.0914306640625,
        1960.80712890625,
        674.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2804.000244140625,
      "bbox_min": [
        1996.8695068359375,
        1919.0877685546875,
        673.5789184570312
      ],
      "bbox_max": [
        2049.195556640625,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -679.5,
      "bbox_min": [
        1996.8695068359375,
        1919.0877685546875,
        673.5789184570312
      ],
      "bbox_max": [
        2049.195556640625,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016458511352539,
        -0.7016417980194092,
        0.12406385689973831
      ],
      "plane_d": 2701.508544921875,
      "bbox_min": [
        1996.8695068359375,
        1919.0877685546875,
        673.5789184570312
      ],
      "bbox_max": [
        2049.195556640625,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -50.47004318237305,
      "bbox_min": [
        1998.8470458984375,
        1921.065185546875,
        673.873291015625
      ],
      "bbox_max": [
        2049.195556640625,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        1998.8470458984375,
        1970.562744140625,
        673.873291015625
      ],
      "bbox_max": [
        1999.697998046875,
        1971.4136962890625,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7067404389381409,
        -0.7074728012084961,
        8.631476521259174e-05
      ],
      "plane_d": -88.60456848144531,
      "bbox_min": [
        2027.13134765625,
        1921.065185546875,
        673.873291015625
      ],
      "bbox_max": [
        2049.195556640625,
        1943.12939453125,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7069846987724304,
        0.7072288393974304,
        0.0
      ],
      "plane_d": 59.5152587890625,
      "bbox_min": [
        2027.13134765625,
        1942.2784423828125,
        673.873291015625
      ],
      "bbox_max": [
        2027.9822998046875,
        1943.12939453125,
        679.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        1996.8695068359375,
        1919.0877685546875,
        673.5789184570312
      ],
      "bbox_max": [
        2048.48828125,
        1970.70654296875,
        675.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071271538734436,
        -0.707086443901062,
        0.0
      ],
      "plane_d": -90.080810546875,
      "bbox_min": [
        2046.3670654296875,
        1919.0877685546875,
        673.5789184570312
      ],
      "bbox_max": [
        2048.48828125,
        1921.2091064453125,
        675.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071087956428528,
        0.7071047425270081,
        -0.0
      ],
      "plane_d": -2836.0,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2822.0,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2068.994384765625,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2818.000244140625,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2059.094970703125,
        1981.313232421875,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -681.0,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2059.094970703125,
        1981.313232421875,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.701643705368042,
        -0.7016477584838867,
        0.12404277920722961
      ],
      "plane_d": 2715.23583984375,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2059.094970703125,
        1981.313232421875,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        -2.1575875507551245e-05
      ],
      "plane_d": -49.98527145385742,
      "bbox_min": [
        2008.743896484375,
        1930.96240234375,
        675.3466186523438
      ],
      "bbox_max": [
        2059.094970703125,
        1981.313232421875,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 20.487060546875,
      "bbox_min": [
        2008.743896484375,
        1980.459716796875,
        675.3466186523438
      ],
      "bbox_max": [
        2009.597412109375,
        1981.313232421875,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 60.0,
      "bbox_min": [
        2037.0283203125,
        1930.96240234375,
        675.3466796875
      ],
      "bbox_max": [
        2059.094970703125,
        1953.0289306640625,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -90.0,
      "bbox_min": [
        2058.24169921875,
        1930.96240234375,
        675.3466796875
      ],
      "bbox_max": [
        2059.094970703125,
        1931.815673828125,
        681.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071107625961304,
        0.7071028351783752,
        5.28855380252935e-05
      ],
      "plane_d": 59.980167388916016,
      "bbox_min": [
        2006.76904296875,
        1928.9873046875,
        675.0526123046875
      ],
      "bbox_max": [
        2058.387939453125,
        1980.6060791015625,
        677.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071271538734436,
        -0.707086443901062,
        0.0
      ],
      "plane_d": -50.0811767578125,
      "bbox_min": [
        2027.9822998046875,
        1957.2716064453125,
        675.0526123046875
      ],
      "bbox_max": [
        2030.103515625,
        1959.3929443359375,
        677.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -682.5,
      "bbox_min": [
        2016.6685791015625,
        1938.8868408203125,
        676.5263061523438
      ],
      "bbox_max": [
        2068.994384765625,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016457319259644,
        -0.7016457319259644,
        0.12404277920722961
      ],
      "plane_d": 2728.94189453125,
      "bbox_min": [
        2016.6685791015625,
        1938.8868408203125,
        676.5263061523438
      ],
      "bbox_max": [
        2068.994384765625,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072288393974304,
        0.7069846987724304,
        0.0
      ],
      "plane_d": 60.4896240234375,
      "bbox_min": [
        2018.641357421875,
        1940.859619140625,
        676.8200073242188
      ],
      "bbox_max": [
        2068.994384765625,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        2.1575875507551245e-05
      ],
      "plane_d": -90.01476287841797,
      "bbox_min": [
        2068.138916015625,
        1940.859619140625,
        676.8200073242188
      ],
      "bbox_max": [
        2068.994384765625,
        1941.7152099609375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7069846987724304,
        -0.7072288393974304,
        4.315925980336033e-05
      ],
      "plane_d": -49.5399055480957,
      "bbox_min": [
        2018.641357421875,
        1969.1439208984375,
        676.8200073242188
      ],
      "bbox_max": [
        2040.710205078125,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0001220703125,
      "bbox_min": [
        2018.641357421875,
        1990.3570556640625,
        676.8200073242188
      ],
      "bbox_max": [
        2019.4969482421875,
        1991.212646484375,
        682.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2016.6685791015625,
        1938.8868408203125,
        676.5263061523438
      ],
      "bbox_max": [
        2068.287353515625,
        1990.505615234375,
        678.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707086443901062,
        -0.7071271538734436,
        0.0
      ],
      "plane_d": -89.91845703125,
      "bbox_min": [
        2066.166015625,
        1938.8868408203125,
        676.5263061523438
      ],
      "bbox_max": [
        2068.287353515625,
        1941.008056640625,
        678.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071047425270081,
        0.7071087956428528,
        -0.0
      ],
      "plane_d": -2849.99951171875,
      "bbox_min": [
        2026.5679931640625,
        1948.7862548828125,
        678.0
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2846.000244140625,
      "bbox_min": [
        2026.5679931640625,
        1948.7862548828125,
        678.0
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -684.0,
      "bbox_min": [
        2026.5679931640625,
        1948.7862548828125,
        678.0
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7016458511352539,
        -0.7016417980194092,
        0.12406385689973831
      ],
      "plane_d": 2742.625732421875,
      "bbox_min": [
        2026.5679931640625,
        1948.7862548828125,
        678.0
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7072288393974304,
        -0.7069846987724304,
        -2.1579573513008654e-05
      ],
      "plane_d": -50.47714614868164,
      "bbox_min": [
        2028.5384521484375,
        1950.75634765625,
        678.2933349609375
      ],
      "bbox_max": [
        2078.89404296875,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 20.0,
      "bbox_min": [
        2028.5384521484375,
        2000.254150390625,
        678.2933349609375
      ],
      "bbox_max": [
        2029.396484375,
        2001.1121826171875,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7067404389381409,
        -0.7074728012084961,
        8.631476521259174e-05
      ],
      "plane_d": -88.5832290649414,
      "bbox_min": [
        2056.822509765625,
        1950.75634765625,
        678.2933349609375
      ],
      "bbox_max": [
        2078.89404296875,
        1972.827880859375,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 59.9998779296875,
      "bbox_min": [
        2056.822509765625,
        1971.9697265625,
        678.2933349609375
      ],
      "bbox_max": [
        2057.6806640625,
        1972.827880859375,
        684.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 60.0,
      "bbox_min": [
        2026.5679931640625,
        1948.7862548828125,
        678.0
      ],
      "bbox_max": [
        2078.186767578125,
        2000.405029296875,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2047.78125,
        1977.070556640625,
        678.0
      ],
      "bbox_max": [
        2049.902587890625,
        1979.19189453125,
        680.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071073651313782,
        0.7071062326431274,
        0.0
      ],
      "plane_d": -2875.0,
      "bbox_min": [
        2018.8876953125,
        1942.5201416015625,
        680.1360473632812
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        700.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -50.0,
      "bbox_min": [
        2018.8876953125,
        1942.5201416015625,
        680.1360473632812
      ],
      "bbox_max": [
        2117.186767578125,
        2040.819091796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": 11.149169921875,
      "bbox_min": [
        2018.8876953125,
        2027.4820556640625,
        680.1361083984375
      ],
      "bbox_max": [
        2032.224853515625,
        2040.819091796875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        2037.931884765625,
        2016.71875,
        690.0
      ],
      "bbox_max": [
        2047.0740966796875,
        2025.8609619140625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071080207824707,
        -0.7071055769920349,
        0.0
      ],
      "plane_d": -110.0048828125,
      "bbox_min": [
        2104.556640625,
        1942.5201416015625,
        680.1360473632812
      ],
      "bbox_max": [
        2117.186767578125,
        1955.1502685546875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071043252944946,
        0.7071092128753662,
        0.0
      ],
      "plane_d": 119.144287109375,
      "bbox_min": [
        2107.519775390625,
        1942.5201416015625,
        680.1361083984375
      ],
      "bbox_max": [
        2117.186767578125,
        1955.1502685546875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3638033866882324,
        0.3638033866882324,
        -0.8574930429458618
      ],
      "plane_d": -887.5048828125,
      "bbox_min": [
        2107.519775390625,
        1945.4835205078125,
        687.2899780273438
      ],
      "bbox_max": [
        2117.186767578125,
        1955.1502685546875,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -89.9998779296875,
      "bbox_min": [
        2066.216064453125,
        1960.150146484375,
        680.1360473632812
      ],
      "bbox_max": [
        2103.642578125,
        1997.57666015625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 60.0,
      "bbox_min": [
        2066.216064453125,
        1984.3485107421875,
        680.1360473632812
      ],
      "bbox_max": [
        2075.3583984375,
        1997.57666015625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        2066.216064453125,
        1988.4344482421875,
        690.0
      ],
      "bbox_max": [
        2075.3583984375,
        1997.57666015625,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 690.0,
      "bbox_min": [
        2094.50048828125,
        1960.150146484375,
        690.0
      ],
      "bbox_max": [
        2103.642578125,
        1969.2923583984375,
        690.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071098685264587,
        0.7071037888526917,
        0.0
      ],
      "plane_d": 119.16650390625,
      "bbox_min": [
        2025.0447998046875,
        1948.67724609375,
        681.0526733398438
      ],
      "bbox_max": [
        2131.328857421875,
        2054.961181640625,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071037888526917,
        -0.7071098685264587,
        0.0
      ],
      "plane_d": 11.16650390625,
      "bbox_min": [
        2025.0447998046875,
        2040.819091796875,
        681.0526733398438
      ],
      "bbox_max": [
        2039.18701171875,
        2054.961181640625,
        700.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2782.99951171875,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        1945.2510986328125,
        1135.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -384.9999694824219,
      "bbox_min": [
        2055.5595703125,
        1869.4814453125,
        370.0
      ],
      "bbox_max": [
        2129.0986328125,
        1945.2510986328125,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        2055.5595703125,
        1871.711669921875,
        370.0
      ],
      "bbox_max": [
        2086.672119140625,
        1902.824462890625,
        370.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        2056.9736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1899.288818359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2056.9736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1899.288818359375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071037292480469,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2809.99951171875,
      "bbox_min": [
        2056.9736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1899.288818359375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.980579674243927,
        0.19612134993076324,
        0.0
      ],
      "plane_d": 1674.4788818359375,
      "bbox_min": [
        2056.9736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1888.5732421875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19610832631587982,
        0.9805822372436523,
        0.0
      ],
      "plane_d": -1429.075927734375,
      "bbox_min": [
        2056.9736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2076.528076171875,
        1881.6112060546875,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 139.0338134765625,
      "bbox_min": [
        2065.33203125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1870.8956298828125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        2065.33203125,
        1869.4814453125,
        648.0
      ],
      "bbox_max": [
        2067.689208984375,
        1870.8956298828125,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2785.000244140625,
      "bbox_min": [
        2056.9736328125,
        1870.4241943359375,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1881.6112060546875,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -128.8798828125,
      "bbox_min": [
        2059.094970703125,
        1870.4241943359375,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1878.0755615234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        370.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        370.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -370.0,
      "bbox_min": [
        2043.1851806640625,
        1859.3372802734375,
        370.0
      ],
      "bbox_max": [
        2064.044677734375,
        1880.1968994140625,
        370.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: backdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "backdr",
      "offset": 40917,
      "centroid": [
        2036.1139526367188,
        1880.5504760742188,
        700.5
      ],
      "bbox_min": [
        2032.224853515625,
        1876.661376953125,
        695.0
      ],
      "bbox_max": [
        2040.0030517578125,
        1884.4395751953125,
        706.0
      ],
      "dimensions_source": {
        "span_x": 7.7781982421875,
        "span_y": 7.7781982421875,
        "height_z": 11.0,
        "door_width": 7.7781982421875,
        "door_depth": 7.7781982421875,
        "leaf_depth": 7.7381982421875,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          0.0,
          -1.0
        ]
      },
      "vertices": [
        [
          2032.9320068359375,
          1884.4395751953125,
          695.0
        ],
        [
          2032.9320068359375,
          1884.4395751953125,
          706.0
        ],
        [
          2032.224853515625,
          1883.732421875,
          706.0
        ],
        [
          2032.224853515625,
          1883.732421875,
          695.0
        ],
        [
          2040.0030517578125,
          1877.3685302734375,
          706.0
        ],
        [
          2040.0030517578125,
          1877.3685302734375,
          695.0
        ],
        [
          2039.2958984375,
          1876.661376953125,
          695.0
        ],
        [
          2039.2958984375,
          1876.661376953125,
          706.0
        ]
      ],
      "plane_distance": 695.0,
      "authentic_texture": "spkelevdoor1"
    }
  ],
  "tutorial_messages": []
}